{
    "LOGIN": {
        "APP-NAME": "{{ appName }} Platform",
        "TITLE": "{{ appName }} Uygulamasına giriş yapın",
        "ACCOUNT-PLACEHOLDER": "Hesap Adı",
        "ACCOUNT-REQUIRED": "Hesap adı zorunludur.",
        "ACCOUNT-SHORT": "Hesap adı en az 2 karakterden oluşmalı.",
        "USERNAME-PLACEHOLDER": "Kullanıcı Adı",
        "USERNAME-REQUIRED": "Kullanıcı adı zorunludur.",
        "USERNAME-SHORT": "Kullanıcı adı en az 2 karakterden oluşmalı.",
        "PASSWORD-PLACEHOLDER": "Şifre",
        "PASSWORD-REQUIRED": "Şifre zorunludur.",
        "PASSWORD-SHORT": "Şifre en az 6 karakterden oluşmalı.",
        "REMEMBER-ACCOUNT-NAME": "Hesap adı otomatik doldurmayı kapat",
        "FORGOT-PASSWORD": "ŞİFRENİ Mİ UNUTTUN?",
        "LOGIN-BUTTON": "GİRİŞ YAP",
        "BACK": "GERİ",
        "SSO-BUTTON": "SSO ile giriş yap",
        "BEFORE-TERMS": "Giriş'e tıklayarak ",
        "TERMS": "Kullanım Koşulları",
        "CONJUNCTION": " ve ",
        "PRIVACY": "Gizlilik Politikası",
        "AFTER-PRIVACY": "'nı kabul etmiş olursunuz.",
        "MORE-OPTIONS": "Daha Fazla Seçenek",
        "ALTERNATIVE-CONN-MODE": "Alternatif Bağlantı Modu",
        "ALTERNATIVE-CONN-CAUTION": "Bu seçeneği seçmek, internet erişiminin yerel ağ koşullarından etkilenebileceği bölgelerde bağlantınızı optimize etmenize yardımcı olur.",
        "VERIFICATION-CODE": "Doğrulama Kodu",
        "VERIFICATION-SENDED": "Size doğrulama kodu içeren bir e-posta gönderdik.",
        "VERIFY-BUTTON": "DOĞRULA",
        "NO-INTERNET-ERROR": "İnternet yok. Lütfen internet bağlantınızı kontrol edin.",
        "USERNAME-PASSWORD-ERROR": "Kullanıcı adı veya şifre yanlış.",
        "INVALID-VERIFICATION-CODE": "Geçersiz iki adımlı doğrulama kodu.",
        "ACCOUNT-DISABLED": "Hesabınızın süresi doldu. Lütfen iletişime geçin {{ contactMail }}",
        "NO-WORKFLOW-LICENSE": "İş akışı lisansı yok. Lütfen iletişime geçin {{ contactMail }}",
        "UNKNOWN-ERROR": "Giriş yaparken bir hata oluştu.",
        "LINK-ID-MISSING": "Bağlantı kimliği eksik",
        "INTERNAL-ERROR": "Bilinmeyen hata",
        "ID-OR-NAME-MISSING": "Bağlantı kimliği veya adı eksik",
        "GUEST-PASSWORD-WRONG": "Workflow şifresi yanlış"
    },
    "USER_PASSWORD": {
        "INVITE_TITLE": "Sifre belirleyin",
        "RESET_TITLE": "Sifrenizi sifirlayin",
        "DESCRIPTION": "{{ username }} icin yeni bir sifre olusturun.",
        "PASSWORD": "Sifre",
        "CONFIRM_PASSWORD": "Sifreyi onayla",
        "REQUIRED": "Bu alan zorunludur.",
        "MIN_LENGTH": "Sifre en az 6 karakter olmali.",
        "REQUIREMENTS_TITLE": "Sifre gereksinimleri:",
        "RULE_MIN_LENGTH": "En az {{ min }} karakter",
        "RULE_MAX_LENGTH": "En fazla {{ max }} karakter",
        "RULE_UPPERCASE": "En az bir buyuk harf (A-Z)",
        "RULE_LOWERCASE": "En az bir kucuk harf (a-z)",
        "RULE_NUMBER": "En az bir rakam (0-9)",
        "RULE_SPECIAL": "En az bir ozel karakter (or. ! @ # $ % & * ?)",
        "RULE_NO_SPACES": "Bosluk icermemeli",
        "RULE_NOT_COMMON": "Yaygin kullanilan bir sifre olmamali",
        "MISMATCH": "Sifreler eslesmiyor.",
        "SUBMIT": "Devam et",
        "SUCCESS": "Sifre basariyla kaydedildi.",
        "INVALID_PASSWORD": "Sifre gereksinimleri karsilamiyor.",
        "LINK_INVALID_TITLE": "Link kullanilamiyor",
        "LINK_INVALID": "Bu link gecersiz, suresi dolmus veya daha once kullanilmis.",
        "LINK_INVALID_STATE": "Bu link artik mevcut kullanici durumuyla eslesmiyor. Yeni bir davet veya sifre sifirlama linki gerekiyor.",
        "LINK_EXPIRED": "Bu linkin suresi dolmus.",
        "LINK_ALREADY_USED": "Bu link daha once kullanilmis.",
        "LINK_SUPERSEDED": "Daha yeni bir davet veya sifre sifirlama linki olusturulmus. Lutfen en son gelen e-postayi kullanin.",
        "BACK_TO_LOGIN": "Giris ekranina don"
    },
    "MAIN": {
        "CONTENT": {
            "DASHBOARD": {
                "NO-WORKFLOW-FOR-NORMAL-USERS": "Boş Liste",
                "NO-WORKFLOW": {
                    "TITLE": "Workflow",
                    "TEXT": "İş süreçlerinizi nasıl basitleştireceğinizi, evrak işlerini nasıl ortadan kaldıracağınızı ve idari görevleri nasıl azaltacağınızı bilmek ister misiniz? Yazılım çözümümüz, insan kaynakları ve iş süreçlerini yönetmenin karmaşıklığını azaltacak iş süreci yönetimi için birleşik, tek bir yazılım çözümüdür. Bu yazılım çözümü, özel ihtiyaçlarınıza göre özelleştirilebilir ve ölçeklenebilir bir teknolojidir.",
                    "CREATE": "Workflow Oluştur"
                },
                "AI-IN-PROGRESS": "AI çalışıyor...",
                "TITLE": "Workflowlar",
                "CREATE": "Workflow Oluştur",
                "GENERATE": "AI ile Otomatik Workflow Oluştur",
                "WORKFLOW-TABLE": {
                    "NAME": "İsim",
                    "VERSION": "Versiyon",
                    "CREATED-BY": "Oluşturan",
                    "STATUS": {
                        "TITLE": "Durum",
                        "PUBLISHED": "Yayınlandı",
                        "DRAFT": "Taslak",
                        "INCOMPLETE": "Tamamlanmamış"
                    },
                    "ACTIONS": {
                        "TITLE": "Aksiyonlar",
                        "OPTIONS": {
                            "TITLE": "Seçenekler",
                            "EDIT": "Taslağı Düzenle",
                            "USERS": "Kullanıcılar",
                            "EASY-GUEST-ACCESS": "Easy Guest Access",
                            "SHARING": "Paylaşım",
                            "PUBLISH": "Taslağı Yayınla",
                            "PUBLISH-VIEW": "Yayınlanan Görünüm",
                            "DUPLICATE": "Workflow'u Kopyala'",
                            "DELETE": "Workflow'u sil",
                            "MOVE-TO-FOLDER": "Klasöre taşı"
                        },
                        "PREFILLED-OPTIONS": {
                            "EDIT": "Düzenle",
                            "SHOW-QR": "QR Göster",
                            "DUPLICATE": "Kopyala",
                            "DELETE": "Sil"
                        },
                        "SUBMITTED-OPTIONS": {
                            "SHOW-REPORT": "Raporu görüntüle",
                            "CHANGE-PREFILLED": "Kısmi dolu olarak değiştir"
                        }
                    },
                    "START": "BAŞLAT",
                    "LAST-EDITED": "Son Değişiklik",
                    "PUBLISHED-AT": "Yayınlandığı Tarih",
                    "LANGUAGES": "Diller",
                    "CONTENT-LANGUAGE": "Workflow İçerik Dili",
                    "FILTER": {
                        "FILTER-BY": "Filtrele",
                        "SELECT-LABEL": "Etiket",
                        "SELECTED-LABELS": "Seçilen Etiketler",
                        "SELECT-STATUS": "Durum",
                        "SELECTED-STATUSES": "Seçilen Durumlar",
                        "CLEAR-ALL": "Tümünü Temizle",
                        "EWERS-SEARCH-PLACEHOLDER": "Tag-ID ile ara",
                        "EWERS-ID-LABEL": "Auftrags-Nr. / Serien-Nr."
                    },
                    "MANAGE-WORKFLOWS": "Workflowları Yönetin"
                },
                "FOLDER": {
                    "MOVE-TO-FOLDER": "Klasöre taşı",
                    "SELECTED": "seçildi",
                    "CREATE-FOLDER": "YENİ KLASÖR OLUŞTUR",
                    "NOT-FOLDERED": "Klasörlenmemiş",
                    "DELETE-FOLDER": "Klasörü Sil",
                    "NO-WORKFLOW-FOUND": "Hiçbir Workflow bulunamadı.",
                    "EDIT-FOLDER": "Düzenle",
                    "MOVE-TO": "Buraya taşı",
                    "FOLDER-NAME": "Klasör adı",
                    "CREATE": "Oluştur",
                    "FOLDERS": "Klasörler",
                    "FOLDER-NAME-UNIQUE-ERROR": "Klasör adı benzersiz olmalıdır.",
                    "DELETE-FOLDER-WARNING-TEXT": "Klasörü silmek istediğinizden emin misiniz?",
                    "DELETE-FOLDER-INFO-TEXT": "Bu klasörün silinmesi, içerdiği Workflowların silinmesine neden olmaz; \"Klasörlenmemiş\" konumuna taşınacaklardır."
                },
                "SEARCH": {
                    "TITLE": "Gelişmiş Arama",
                    "PLACEHOLDER": "Arama sorgusu girin...",
                    "BUTTON": "Ara",
                    "CANCEL": "İptal",
                    "CLEAR": "Aramayı Temizle",
                    "RESULTS": "Arama Sonuçları",
                    "NO_RESULTS": "Arama sorgunuz için workflow bulunamadı.",
                    "ERROR": "Arama başarısız oldu. Lütfen tekrar deneyin.",
                    "APPLIED": "Arama uygulandı"
                },
                "TEXT-MESSAGE": "Değişiklikleriniz kaybolacaktır. Bu Workflow'u silmek istediğinizden emin misiniz?",
                "TEXT-MESSAGE-PUBLISH-VIEW": "Düzenleme moduna geçeceksiniz. Son güncellenen taslak üzerinden devam edebilirsiniz.",
                "TEXT-MESSAGE-UNSAVED-CHANGES": "Kaydedilmemiş değişiklikler mevcut. Bu değişiklikler kaydedilecek sonrasında yayınlanacaktır.",
                "TEXT-MESSAGE-CLOSE-WORKFLOW": "Workflow'u kapatmak istediğinizden emin misiniz? Değişiklikleriniz kaybolacaktır.",
                "TEXT-MESSAGE-CONDITIONAL-WORKFLOW": "Açmaya çalıştığınız Workflow koşullu bir Workflow'dur. Web versiyonu koşullu workflow desteklemez",
                "TEXT-MESSAGE-PREFILLED-EDIT": "Düzenleme yaptığınızda, yeni bir qr ve bağlantı oluşturulması gerekecektir. Önceki QR kodu ve bağlantı geçersiz olacaktır.",
                "TEXT-MESSAGE-PREFILLED-EDIT-TITLE": "Önceden Doldurulmuş Workflow'u Düzenle",
                "CANCEL": "İPTAL",
                "CLOSE": "KAPAT",
                "EXPORT-WORKFLOWS": "DIŞA AKTAR",
                "SAVE-AS-DRAFT": "Taslak olarak kaydet",
                "CONTINUE": "Devam Et",
                "UPDATE": "Güncelle",
                "CONTINUE-UPPERCASE": "DEVAM ET",
                "START-OVER": "BAŞTAN BAŞLA",
                "WORKFLOW-STARTED": "Workflow'u zaten başlattınız. Devam etmek mi yoksa yeni bir tane başlatmak mı istiyorsunuz?",
                "NEW-VERSION": "Bu Workflow açılamıyor. Workflow'un yeni sürümünü yayınlamanız gerekiyor",
                "ANOTHER-COPY": "Bu workflow'un bir kopyası, adının sonuna \"(Copy)\" eklenerek sürüm 1 ve taslak halinde oluşturulacak. Tüm adımları, alanları ve dosyaları da kopyalanır.",
                "DUPLICATE-SUCCESSFUL": "Workflow başarıyla kopyalandı.",
                "DUPLICATE-NESTED-SKIPPED": "İç içe workflow bağlantıları kopyalanmadı.",
                "DUPLICATE-FILES-FAILED": "{{count}} dosya kopyalanamadı. Kopya hâlâ özgün dosyaları gösteriyor.",
                "DUPLICATE-PARTIAL": "Kopya oluşturuldu, ancak dosyaların kopyalanması tamamlanmadı. Kopyayı açıp medya içeriğini denetleyin.",
                "DUPLICATE-ERROR": "Bu workflow kopyalanamaz.",
                "DELETE-SUCCESSFUL": "Silme işlemi başarılı",
                "DELETE-ERROR": "Silme Hatası",
                "WORKFLOW-NOT-FOUND": "Workflow bulunamadı",
                "CREATION-LIMIT": "Workflow oluşturma sınırına ulaşıldı",
                "PUBLISH-SUCCESSFUL": "Yayınlama Başarılı",
                "PUBLISH-ERROR": "Yayın Hatası",
                "EXPORT-CANCELED": "Dışa aktarma iptal edildi",
                "EXPORT-FOLDER": "Dışa aktarma klasörü mevcut",
                "EXPORT-SUCCESSFUL": "Dışa aktarma başarılı",
                "YES": "EVET",
                "DELETE-REPORT-TITLE": "Raporu Sil",
                "DELETE-REPORT-TEXT": "Raporu silmek istediğinizden emin misiniz?",
                "SAVE-PREFILLED-TITLE": "Değişiklikleri Kaydet",
                "SAVE-PREFILLED-TEXT": "Değişiklikleriniz kaydedilecektir. Devam etmek istediğinizden emin misiniz?",
                "CONNECTED-WORKFLOW-WARNING-TEXT": "Bu Workflow başka bir Workflow'a bağlı olduğu için silinemez. Önce bağlı olan Workflow'dan çıkarmanız gerekmektedir.",
                "SUBMITTED-REPORT-TO-PREFILLED-TEXT": "Bu raporu önceden doldurulmuş rapor olarak değiştirmek istediğinizden emin misiniz?",
                "SUBMITTED-REPORT-TO-PREFILLED-TITLE": "Rapor Durumunu Değiştir",
                "NESTED-WORKFLOWS-CONNECTION-ENABLE-WARNING": "Eklediğiniz Workflow'da bağlantı var. Bu nedenle bağlantı mevcut Workflow'da da etkinleştirilecektir. Workflow'u kaydettikten sonra bağlantılar sayfasını kontrol edin.",
                "TABS": {
                    "MY-WORKFLOWS": "Workflowlarım",
                    "SUBMITTED-WORKFLOWS": "Gönderilen Workflowlar",
                    "SHARED-WORKFLOWS": "Paylaşılan İş Akışları",
                    "SHARED-WORKFLOW": "Paylaşılan İş Akışı"
                },
                "VIEW-MODES": {
                    "LIST": "Liste",
                    "FOLDER": "Klasör"
                }
            },
            "REMOTE": {
                "IMAGE-COLLABORATION": {
                    "UNDO": "Geri al",
                    "REDO": "Yeniden yap",
                    "ANNOTATE": "Açıklama ekle",
                    "REVERT": "Geri al",
                    "ZOOM-IN": "Yakınlaştır",
                    "ZOOM-OUT": "Uzaklaştır",
                    "UP": "Yukarı",
                    "DOWN": "Aşağı",
                    "LEFT": "Sol",
                    "RIGHT": "Sağ"
                }
            },
            "REPORT": {
                "NAME": "İsim",
                "DESCRIPTION": "Açıklama",
                "STEPS-COMPLETED": "Tamamlanan Adımlar",
                "START": "Başlangıç",
                "END": "Bitiş",
                "DURATION": "Süre",
                "EXPORT": "Dışa Aktar (CSV)",
                "SUBMITTED-BY": "Gönderen",
                "PREFILLED-BY": "İlk Dolduran",
                "PREFILLED-AT": "Başlangıç",
                "QR-SCANNED-AT": "QR Taratıldığı Zaman",
                "SAVE-PDF": "PDF olarak kaydet",
                "STEP-LIST": {
                    "NAME": "Task adı",
                    "CONTENT": "İçerik",
                    "DURATION": "Süre",
                    "NO-CONTENT": "N/A",
                    "DETECTED": "Tespit Edildi",
                    "NOT-DETECTED": "Tespit Edilemedi",
                    "MATCHED": "Eşleşti",
                    "NOT-MATCHED": "Eşleşmedi",
                    "ENTERED-VALUE": "Girilen Değer",
                    "SCANNED-VALUE": "Taranan Değer"
                },
                "FILES": "Dosyalar",
                "OPTIONS": "Seçenekler",
                "APPROVAL": {
                    "TITLE": "Onay",
                    "DESCRIPTION-TEXT": "Bu rapora onay vermek için lütfen aşağıdaki alanı imzalayınız.",
                    "SIGN": "İMZALA",
                    "RESEND": "Onay İsteğini Yeniden Gönder",
                    "NOT-SIGNED": "İMZALANMADI",
                    "DELETE-APPROVAL": "Silmek istediğinizden emin misiniz?",
                    "DELETE": "Sil"
                },
                "SELECT-LANGUAGE": "Dil Seçin",
                "MISSING-PARAMETERS": "Eksik parametreler var",
                "INVALID-TOKEN": "Geçersiz Token",
                "REPORT-NOT-FOUND": "Rapor bulunamadı",
                "SUCCESSFULLY-SENDED": "Başarıyla gönderildi",
                "REMOTE-CALL": {
                    "TITLE": "Remote Aramalar",
                    "STATUS": "Durum",
                    "STEP": "Adım",
                    "USERS": "Katılımcılar",
                    "GUEST": "Misafir",
                    "CALL-FAILED": "Çağrı başlatılmadı",
                    "CREATED-AT": "Oluşturulma tarihi"
                },
                "LOADING": "Yükleniyor..."
            },
            "REPORT-LIST": {
                "NO-REPORT": {
                    "TITLE": "Workflow Raporu",
                    "TEXT": "Hiç rapor yok.",
                    "NO-REPORT-FOUND": "Belirtilen bağlantı kimliğiyle ilişkili rapor bulunamadı"
                },
                "TITLE": "Raporlar",
                "PLACEHOLDER": "İsme göre ara",
                "LIST": {
                    "WORKFLOW": "Workflow",
                    "VERSION": "Versiyon",
                    "SUBMITTED-BY": "Gönderen",
                    "SUBMITTED-TITLE": "Gönderildi",
                    "SUBMITTED": "Gönderildi",
                    "APPROVAL": "Onay",
                    "APPROVED": "Onaylandı",
                    "PENDING": "Beklemede",
                    "VIEW": "Görüntüle",
                    "PREFILLED": "Kısmi Dolu"
                },
                "LAST-SAVED": "Son Kaydedilme",
                "PERMISSION-ERROR": "Rapor verisini görme yetkiniz yoktur.",
                "ERROR": "HATA",
                "IMPORT-CANCELED": "İçe aktarma iptal edildi",
                "REPORT-FORMAT-WRONG": "Rapor formatı yanlış",
                "IMPORT-SUCCESSFUL": "İçe aktarma başarılı",
                "FILTER-ID": "ID etiketine göre ara",
                "ID-TAG": "ID etiketi",
                "IMPORT_REPORTS": "RAPORLARI İÇE AKTAR",
                "WORKFLOW_REPORTS": "Workflow Raporları",
                "REMOTE_SESSIONS": "Uzaktan Yardım Oturumları",
                "OPTIONS": "Seçenekler"
            },
            "USER-DETAIL": {
                "CREATE_TITLE": "Kullanıcı Oluştur",
                "INVITE_TITLE": "Kullanıcı Davet Et",
                "EDIT_TITLE": "Kullanıcı Düzenle",
                "EDIT_DETAILS": "Kullanıcı Düzenle",
                "NAME": "İsim",
                "NAME_REQUIRED": "İsim zorunludur.",
                "NAME_PATTERN": "İsim yalnızca harf, rakam, alt çizgi ( _ ) ve kısa çizgi ( - ) içerebilir.",
                "USERNAME": "Kullanıcı Adı",
                "USERNAME_REQUIRED": "Kullanıcı adı zorunludur.",
                "USERNAME_PATTERN": "Kullanıcı adı yalnızca harf, rakam, alt çizgi ( _ ) ve kısa çizgi ( - ) içerebilir..",
                "USERNAME_EXISTS": "Bu kullanıcı zaten kayıtlı",
                "EMAIL": "E-posta",
                "EMAIL_REQUIRED": "E-posta zorunludur.",
                "INVALID_EMAIL": "Geçersiz e-posta formatı",
                "SAVE_CHANGES": "KAYDET",
                "DELETE_USER": "KULLANICI SİL",
                "CHANGE_PASSWORD": "Şifre Değiştir",
                "CREATE_PASSWORD": "Şifre Oluştur",
                "NEW_PASSWORD": "Yeni Şifre",
                "CONFIRM_NEW_PASSWORD": "Yeni Şifre Onay",
                "SUBMIT_NEW_PASSWORD": "ŞİFRE DEĞİŞTİR",
                "PASSWORD_REQUIRED": "Şifre zorunludur.",
                "PASSWORD_REQUIREMENTS": "Şifre aşağıdaki gereksinimleri karşılamıyor.",
                "CONFIRM_PASSWORD": "Şifre Onayla",
                "CONFIRM_REQUIRED": "Şifre onayı zorunludur.",
                "PASSWORD_MATCH": "Şifreler eşleşmedi.",
                "PASSWORD_MUST": "Şifre:",
                "MIN_LENGTH": "En az {{ minPasswordLength }} karakter içermeli ",
                "UPPERCASE": "En az bir büyük harf içermeli (A-Z) ",
                "LOWERCASE": "En az bir küçük harf içermeli (a-z) ",
                "NUMBER": "En az bir rakam içermeli (0-9) ",
                "SPECIAL": "En az bir özel karakter içermeli (-*/?#&()) ",
                "SUBMIT": "KULLANICI OLUŞTUR",
                "QR_CODE": "QR Kod",
                "AUTHENTICATE": "Akıllı gözlük ve cep telefonlarını QR kodunuz ile doğrulayabilirsiniz.",
                "GENERATE_QR_CODE": "QR OLUŞTUR",
                "REGENERATE_QR_CODE": "QR kodu yeniden oluştur",
                "DOWNLOAD": "İndir",
                "DELETE": "Sil",
                "LIMIT-WARNING": "Kullanıcı oluşturulacak ancak Workflow kullanıcı sınırınız dolu. Bu kullanıcı, Workflow kullanıcısı olarak oluşturulmayacak.",
                "DELETE-USER-OR-NOT": "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
                "DELETE-QR-OR-NOT": "Bu QR kodunu silmek istediğinizden emin misiniz?",
                "CREATED-SUCCESSFULLY": "Kullanici basariyla olusturuldu. Ancak Workflow kullanici siniriniz dolu. Bu kullanici bir Workflow kullanicisi degil",
                "INVITE-SENT": "Kullanici olusturuldu ve davet e-postasi gonderildi.",
                "INVITE-RESENT": "Davet e-postasi yeniden gonderildi.",
                "SEND_INVITE": "Davet Gonder",
                "RESET-SENT": "Sifre sifirlama e-postasi gonderildi.",
                "RESEND_INVITE": "Daveti Yeniden Gönder",
                "RESET_PASSWORD_EMAIL": "Şifre sıfırlama e-postası gönder",
                "RESET_PASSWORD_EMAIL_REQUIRED": "Önce kullanıcının e-posta adresi ayarlanmalıdır.",
                "ROLE": "Rol",
                "MORE_SETTINGS": "Daha Fazla Ayar",
                "EDITOR-ACCESS": "Editör Erişimi",
                "EDITOR-ACCESS-TEXT": "Kullanıcının Workflowlar oluşturabilmesi ve düzenleyebilmesi için kullanıcıya editöre erişim verilecektir.",
                    "REMOTE-ASSISTANCE": "Uzaktan Yardım Ayarları",
                "WEAK-PASSWORD-WARNING": "'123456' gibi zayıf şifreler oluşturmayın."
            },
            "USER-LIST": {
                "TITLE": "Kullanıcılar",
                "CREATE": "Kullanıcı Oluştur",
                "SIMPLIFY": "İş süreçlerinizi nasıl basitleştireceğinizi, evrak işlerini nasıl ortadan kaldıracağınızı ve idari görevleri nasıl azaltacağınızı bilmek ister misiniz? Yazılım çözümümüz, insan kaynakları ve iş süreçlerini yönetmenin karmaşıklığını azaltacak iş süreci yönetimi için birleşik, tek bir yazılım çözümüdür. Bu yazılım çözümü, özel ihtiyaçlarınıza göre özelleştirilebilir ve ölçeklenebilir bir teknolojidir.",
                "LICENSED": "Lisanslı Workflow Kullanıcıları: ",
                "LICENSED-EXPERT": "Lisanslı Uzman Kullanıcıları: ",
                "SEARCH": "Ara",
                "UNLIMITED": "Unlimited",
                "LIST": {
                    "WORKFLOW-USER": "Workflow Kullanıcısı",
                    "NAME": "İsim",
                    "USERNAME": "Kullanıcı Adı",
                    "MEMBERS": "Üyeler"
                },
                "ACTIONS": {
                    "OPTIONS": "Seçenekler",
                    "EDIT": "Düzenle",
                    "DELETE": "Sil"
                },
                "LICENCE-LIMIT": "Hesabınız, maksimum workflow gönderim sayısına ulaştı. En yeni workflow gönderimlerini görmek için lütfen lisansınızı yükseltin.",
                "DEACTIVATE": {
                    "DEACTIVATED": "kullanıcı devre dışı bırakıldı",
                    "SAVE": "Kaydet",
                    "CANCEL": "İptal"
                },
                "CHANGES-WARNING": "Kaydedilmemiş değişiklikler mevcut. Kapatmak istediğinizden emin misiniz?",
                "DELETE-OR-NOT": "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
                "SAVE-SUCCESSFUL": "Kaydetme Başarılı",
                "LIMIT-EXCEED": "Limit aşımı.",
                "ERROR": "Hata",
                "INVITE_PENDING": "Bekliyor",
                "USERS-AND-TEAMS": "Kullanıcılar & Ekipler",
                "TEAMS": "Ekipler",
                "CREATE-TEAM": "EKIP OLUŞTUR",
                "TEAM": "Ekip",
                "CREATE-WORK-GROUP": "ÇALIŞMA GRUBU OLUŞTUR",
                "WORK-GROUPS": "Çalışma Grupları",
                "USER-ACTIVATED": "kullanıcı etkinleştirildi",
                "LIMIT-EXCEEDED": "! Limit aşıldı",
                "SAMPLE": {
                    "TEAM-NAME": "Pazarlama",
                    "MEMBER-COUNT": "10 Üye"
                }
            },
            "WORKFLOW": {
                "REQUIRED": "Zorunlu Alan",
                "SIDEBAR": {
                    "DETAILS": "Detaylar",
                    "EDITOR": "Editör",
                    "CONNECTIONS": "Bağlantılar"
                },
                "WORKFLOW-DETAIL": {
                    "TITLE": "Detaylar",
                    "NAME": {
                        "TITLE": "İsim",
                        "REQUIRED": "zorunlu",
                        "NO-NAME": "Bu alan zorunludur"
                    },
                    "DESCRIPTION": "Açıklama",
                    "DURATION": "Tahmini Süre",
                    "LABEL": {
                        "TITLE": "Etiketler",
                        "CREATE": "yeni oluştur",
                        "NO-ITEMS-FOUND": "Öğe bulunamadı"
                    },
                    "SHOW-CONTENT-PAGE": "İçerik Sayfasını Göster",
                    "UPLOAD-FILE": "Dosya Yükle",
                    "PREVIEW-TEXT": "Workflow'u düzenlemek için, Editör sekmesine gidiniz.",
                    "UPLOAD-FILE-INFO": "Bu Workflow hakkında bilgi içeren dosyaları yükleyebilirsiniz. Şu anda sadece PDF desteği var.",
                    "CONNECTION-WARNING": "“Bağlantılar” aktif olduğu için “Content Page” aktifleştirilemez.",
                    "DELETE-FILE": "Bu dosyayı silmek istediğinizden emin misiniz?",
                    "REMOTE-CALL-EXPERTS": "Uzmanla Uzaktan Görüşme"
                },
                "WORKFLOW-STEPS": {
                    "STEP-LIST": {
                        "INFORM": "Aşağıdaki butonla adım oluşturun",
                        "STEP": {
                            "NO-NAME": "Adım adı zorunludur.",
                            "OPTIONS": {
                                "RENAME": "Yeniden Adlandır",
                                "DUPLICATE": "Kopyala",
                                "DELETE": "Sil",
                                "MOVE": "Taşı",
                                "CLONE": "Klonla",
                                "CLONE-STEP": "Adımı Klonla",
                                "MOVE-STEP": "Adımı Taşı"
                            },
                            "CREATE": "Yeni Adım Oluştur",
                            "ADD-STEP": "Adım Ekle"
                        },
                        "MANAGE-STEPS": {
                            "TITLE": "Adımları Yönet",
                            "DELETE": "Sil",
                            "DUPLICATE": "Kopyala",
                            "CLONE": "Klonla",
                            "MOVE": "Taşı",
                            "SELECT-ALL": "Hepsini Seç",
                            "DESELECT-ALL": "Hiçbirini Seçme",
                            "CONNECTION-VIEW-DISABLED": "Bağlantı modu nedeniyle devre dışı"
                        },
                        "TEXT-MESSAGE": "Değişiklikleriniz kaybolacaktır. Bu adımı silmek istediğinizden emin misiniz?",
                        "CLONE-TEXT-MESSAGE": "Seçtiğiniz adım, seçilen Workflow'a kopyalanacaktır.",
                        "MOVE-TEXT-MESSAGE": "Seçtiğiniz adım, seçilen Workflow'a kopyalanacak ve bu adım bu Workflow'dan silinecek.",
                        "SELECT": "Seç",
                        "CREATE-SECTION": "Grup Oluştur",
                        "SECTION-TEXT-MESSAGE": "Bu Workflow'da grup yok. Grup oluşturulacak ve daha önce oluşturulan adımlar buna eklenecektir. Devam etmek istiyor musunuz?",
                        "SECTION-DELETE-TEXT-MESSAGE": "Bu grubu sildiğinizde grup altındaki adımlar da silinecektir. Silinmesini istemediğiniz adımları silmeden önce taşıyabilirsiniz.",
                        "INDEPENDENT": "Adımlar bölümden bağımsız olamaz",
                        "DELETE-STEP": "Seçilen adımlar silinecek. Aşağıdaki adımları silmek istediğinizden emin misiniz?",
                        "INITIAL-STEP-WARNING-MESSAGE": "Seçilen adım Workflow'un ilk adımıdır. Silmeden önce ilk adımı değiştirmeniz gerekir.",
                        "CONNECTED-STEPS-WARNING-MESSAGE": "Bu adımlarla bağlantılı adımlar vardır. Bu adımı silerseniz bağlantılarınız kaybolur. Lütfen 'Connections' sayfasındaki bağlantılarınızı kontrol edin."
                    },
                    "STEP-PREVIEW": {
                        "NO-STEP": "Seçilmedi"
                    },
                    "WIDGET-PROPERTIES": {
                        "EMPTY": "İçerik eklemek için tıklayınız.",
                        "INFORM": "Önizlemede eklediğiniz Widget'lar ile birlikte bütün halinin önizlemesini görebilirsiniz.",
                        "BACK": "Geri",
                        "POSITION": {
                            "TITLE": "Pozisyon",
                            "HORIZONTAL": "Yatay pozisyon",
                            "VERTICAL": "Dikey pozisyon"
                        },
                        "LABEL": {
                            "TITLE": "Başlık",
                            "REQUIRED": "zorunlu",
                            "NO-LABEL": "Bu alan zorunludur."
                        },
                        "PLACEHOLDER": "Placeholder",
                        "OPTIONS": {
                            "TITLE": "Seçenekler",
                            "NO-LABEL": "Bu alan zorunludur.",
                            "MUST-UNIQUE": "Seçenekler aynı olmamalı",
                            "DELETE-LAST": "- Tek kalan seçenek silinemez",
                            "ADD": "Seçenek Ekle",
                            "MAX-ADDED": "Çok sayıda öğe eklemek akıllı gözlüklerde kaydırma gerektirebilir."
                        },
                        "NUMBER-FIELDS": {
                            "MIN": "Min",
                            "MAX": "Maks",
                            "UNIT": "Birim",
                            "PRECISION": "Hassasiyet"
                        },
                        "PPE-FIELDS": {
                            "TITLE": "Aşağıdaki ekipmanları tespit edin:",
                            "FACE": "Yüz ekipmanı",
                            "HEAD": "Kafa ekipmanı",
                            "HAND": "El ekipmanı",
                            "NO-RECOGNITION": "En az bir PPE tanıma seçilmelidir."
                        },
                        "TIME-PICKER": "Tarih saati kapsasın",
                        "QR-FIELD": "QR kod değeri",
                        "QR-ACTIVATION": "QR Doğrulamasını Etkinleştir",
                        "QR-FIELD-VALIDATION-TEXT": "QR zorunludur.",
                        "QR-ACTIVATION-INFO-TEXT": "QR doğrulaması etkinleştirildiğinde, girdiğiniz QR kodu değeri (QR bağlantısı), kullanıcı tarafından taranan QR koduyla eşleşip eşleşmediklerini belirlemek için karşılaştırılır.",
                        "REQUIRED": {
                            "TEXT": "Bu alanı zorunlu yap",
                            "INFORM": "Bu alanın zorunlu olmasını istiyorsanız aktifleştirebilirsiniz."
                        },
                        "IMAGE": {
                            "TITLE": "Resim Yükle",
                            "REQUIRED": "zorunlu",
                            "UPLOAD": {
                                "DRAG-DROP": "Sürükle & Bırak",
                                "INFORM": "Dosya sürükle veya butona tıkla",
                                "CLICK": {
                                    "UPLOAD": "Resim Yükle",
                                    "CHANGE": "Resmi Değiştir",
                                    "EDIT": "Resmi düzenle"
                                }
                            },
                            "NO-IMAGE": "Resim zorunludur"
                        },
                        "GALLERY": {
                            "TITLE": "Resim Yükle",
                            "REQUIRED": "zorunlu",
                            "NO-IMAGE": "Resim zorunludur",
                            "DELETE-IMAGE-TEXT-MESSAGE": "Bu resmi silmek istediğinizden emin misiniz?",
                            "VALIDATION-TEXT": "En fazla 50 resim yüklenebilir.",
                            "DELETE-IMAGE": "Resmi Sil"
                        },
                        "VIDEO": {
                            "TITLE": "Video Yükle",
                            "REQUIRED": "zorunlu",
                            "UPLOAD": {
                                "DRAG-DROP": "Sürükle & Bırak",
                                "INFORM": "Dosya sürükle veya butona tıkla",
                                "CLICK": {
                                    "UPLOAD": "Video Yükle",
                                    "CHANGE": "Video Değiştir"
                                }
                            },
                            "NO-IMAGE": "Video zorunludur."
                        },
                        "PDF": {
                            "TITLE": "PDF Yükle",
                            "REQUIRED": "zorunlu",
                            "UPLOAD": {
                                "DRAG-DROP": "Sürükle & Bırak",
                                "INFORM": "Dosya sürükle veya butona tıkla",
                                "CLICK": {
                                    "UPLOAD": "PDF Yükle",
                                    "CHANGE": "PDF Değiştir"
                                }
                            },
                            "NO-IMAGE": "PDF zorunludur."
                        },
                        "TABLE": {
                            "CREATE-TABLE": "Tablo Oluştur",
                            "COLUMN": "Sütun",
                            "ROW": "Satır",
                            "CREATE": "Oluştur",
                            "ADD-ROW": "Satır Ekle",
                            "DELETE-ROW": "Satır Sil",
                            "ADD-COLUMN": "Sütun Ekle",
                            "DELETE-COLUMN": "Sütun Sil",
                            "SELECT-CELL-TEXT": "Tabloyu doldurmak için lütfen bir hücre seçin",
                            "SELECT-CONTENT-TYPE-TEXT": "İçerik türünü seçin",
                            "SELECTED": "Seçilen : ",
                            "COLUMN-VALIDATION-TEXT": "Sütun sayısı en az 1 olmalıdır.",
                            "ROW-VALIDATION-TEXT": "Satır sayısı en az 1 olmalıdır.",
                            "CLEAR": "İçeriği temizle",
                            "HEADER-CELL-INFO": "Başlık hücreleri sadece sütun isimleri içerebilir",
                            "Label": "Metin",
                            "Input": "Metin Girişi",
                            "Number": "Sayı Girişi",
                            "Datepicker": "Tarih Seçici",
                            "Checkbox": "Onay Kutusu",
                            "Radio": "Tek Seçim"
                        },
                        "TEXT-MESSAGE": "Widget'ı değiştirmek istediğinizden emin misiniz?",
                        "DELETE-TEXT-MESSAGE": "Widget'ı silmek istediğinizden emin misiniz?",
                        "TITLE-DELETE": "Widget'ı Sil",
                        "TITLE-CHANGE": "Widget'ı Değiştir",
                        "REPLACE": "Değiştir",
                        "DELETE-ROW-TEXT-MESSAGE": "Bu satırı silmek istediğinizden emin misiniz?",
                        "DELETE-COLUMN-TEXT-MESSAGE": "Bu kolonu silmek istediğinizden emin misiniz?",
                        "TITLE-DELETE-ROW": "Satırı Sil",
                        "TITLE-DELETE-COLUMN": "Kolonu Sil",
                        "CONNECTION-WARNING-TEXT-MESSAGE": "Bu widget'ı değiştiremezsiniz. Çünkü bir koşul bu widget'ı içerir.",
                        "CONNECTION-WARNING-HEADER": "Koşullu Workflow Uyarısı",
                        "WIDGET-TITLES": {
                            "LABEL": "Metin",
                            "TEXT-INPUT": "Metin Girişi",
                            "NUMBER-INPUT": "Sayı Girişi",
                            "DATE-PICKER": "Tarih Seçici",
                            "CHECKBOX": "Onay Kutusu",
                            "RADIO-BUTTON": "Tek Seçim",
                            "IMAGE": "Görsel",
                            "VIDEO": "Video",
                            "PDF": "PDF",
                            "DETECT-QR": "QR Tara",
                            "CAPTURE-IMAGE": "Fotoğraf Çek",
                            "CAPTURE-VIDEO": "Video Kaydet",
                            "PPE": "KKD Tespiti",
                            "VOICE-RECORD": "Ses Kaydı",
                            "VOICE": "Ses",
                            "VSIGHT-REMOTE": "VSight Remote",
                            "AR-INSTRUCTION": "AR Talimatı",
                            "HTML": "Zengin Metin",
                            "GALLERY": "Galeri",
                            "TABLE": "Tablo",
                            "FORM": "Form",
                            "WORKFLOW": "Workflow",
                            "ID": "Etiket ID",
                            "SIGNATURE": "İmza"
                        },
                        "WIDGET-DESCRIPTION": {
                            "INSTRUCTION": "Talimat",
                            "FEEDBACK": "Geri Bildirim",
                            "VISUAL-SUPPORT": "Canlı Destek",
                            "AUGMENTED-REALITY": "Artırılmış Gerçeklik",
                            "VISUAL-AI": "Görsel Yapay Zeka",
                            "COMING-SOON": "Yakında",
                            "FULLSCREEN": "Yalnızca tam sayfada kullanılabilir"
                        },
                        "LIMIT-EXCEED": "Limit aşımı. Maksimum sınır 50'dir."
                    },
                    "STEP-FILES": {
                        "TITLE": "Dosyalar",
                        "VIEW-STEP-FILES": "Dosyaları Görüntüle"
                    }
                },
                "TITLE": "Workflow",
                "APPROVE": "Onayla",
                "CANCEL": "İptal",
                "SAVE": "Taslağı Kaydet",
                "PUBLISH": "Yayınla",
                "SAVE-PUBLISH": "Kaydet & Yayınla",
                "EDIT-WORKFLOW": "WORKFLOW'U DÜZENLE",
                "EDIT-WORKFLOW-TITLE": "Workflow Düzenle",
                "EDIT-MODE-TEXT-MESSAGE": "Görüntüleme modundasınız. Değişiklik yapmak için 'WORKFLOW'U DÜZENLE' butonuna tıklayın.",
                "STEP-PREVIEW": "Önizleme",
                "WIDGET-PROPERTIES": "Widget eklemek için alanlardan birini seçin.",
                "CONNECTIONS-PAGE": "bağlantılar",
                "CHANGE-STEP-LAYOUT": "Şablonu değiştir",
                "ERROR-MESSAGE": {
                    "MESSAGE": "Alanlardan biri boş olmadığı sürece tam sayfa moduna geçemezsiniz..",
                    "NOT-SUPPORT": "Bu tür, seçilen şablonu desteklemiyor.",
                    "CONFIRM": "Kapat"
                },
                "TEXT-MESSAGE": {
                    "MESSAGE": "Editörü kapatmak istediğinizden emin misiniz? Kaydedilmemiş değişiklikler kaybolacak.",
                    "CONFIRM": "Kapat",
                    "OK": "Tamam",
                    "SWITCH-MODE-MESSAGE": "Mod değiştirmek istediğinize emin misiniz?"
                },
                "PREVIEW": {
                    "DETECT-QR": "QR Kodunu/Barkodunu Algıla",
                    "DETECT-PPE": "Kameradan PPE Algılama",
                    "PICK_IMAGE": "Resim Seç",
                    "PICK-VIDEO": "Video Seç",
                    "CAPTURE-IMAGE": "Resim yükle",
                    "CAPTURE-VIDEO": "Video yükle",
                    "DETECT-PPE-FROM-FINDER": "Bir PPE Resmi Seçin",
                    "DETECT-QR-WITH-UPLOAD": "QR Görüntüsü Seçin",
                    "DETECT-QR-WITH-CAMERA": "QR Kodunu/Barkodu Algıla",
                    "SIGN-HERE": "Buraya imzalayın"
                },
                "WORKFLOW-CONNECTIONS": {
                    "CONDITIONS": "Koşullar",
                    "ADD-CONDITION": "Koşul Ekle",
                    "INFORM-TEXT": "Koşul eklemek için adımlardan birini seçmelisin.",
                    "FROM": "Nereden",
                    "TO": "Nereye",
                    "DELETE-CONNECTION": "Koşul sil",
                    "WHEN": "When",
                    "REQUIRED-FIELD": "Zorunlu alan",
                    "ADD-LOGICAL-CONDITION": "Mantıksal koşul ekle",
                    "DELETE-CONDITION": "Koşul Sil",
                    "CONDITION": "Koşul",
                    "GO-TO": "Git",
                    "ELSE-CONDITION-TEXT": "Eğer koşullar sağlanmadıysa, git",
                    "NOT-SELECTED": "Seçilmedi",
                    "TURN-ON-CONNECTIONS": "Etkinleştir",
                    "TURN-ON-CONNECTIONS-TEXT": "Koşullu workflow düzenlemek istiyorsanız lütfen 'Etkinleştir' butonuna tıklayın",
                    "SELECT": "Seç",
                    "ENTER": "Giriniz",
                    "CONTENT-PAGE-WARNING-TEXT": "Bağlantıları açmak istediğinize emin misiniz?",
                    "CONTENT-PAGE-IMPORTANT-WARNING-TEXT": "DİKKAT: Bağlantıların açılması, bu iş akışındaki “Content Page” özelliğini kalıcı olarak devre dışı bırakacaktır.",
                    "CONFIRM": "Evet",
                    "INITIAL-STEP-CHANGE-TEXT": "Buraya tıklayarak başlangıç adımını değiştirebilirsiniz",
                    "INITIAL-STEP-CHANGE-WARNING-TEXT": "Seçilen adıma bağlı başka adımlar olduğu için bu adım başlangıç adımı olamaz.",
                    "INVALID-DATA": "Geçersiz veriler nedeniyle bu adım otomatik olarak kaydedilemez.",
                    "ALREADY-CONNECTED": "Halihazırda bağlı olan adımlar arasında bir bağlantı oluşturamazsınız."
                },
                "HEADER-TITLES": {
                    "CLOSE-WORKFLOW": "Workflow'u Kapat",
                    "PUBLISH-WORKFLOW": "Workflow'u Yayınla",
                    "DELETE-USER": "Kullanıcı Sil",
                    "DELETE-WORKFLOW": "Workflow Sil",
                    "WARNING": "Uyarı",
                    "DELETE-FILE": "Dosya Sil",
                    "DELETE-SECTION": "Grup Sil",
                    "DELETE-STEP": "Adım Sil",
                    "LOGOUT": "Çıkış Yap",
                    "LICENCE-WARNING": "Lisans Uyarısı",
                    "DUPLICATE-WORKFLOW": "Workflow'u Kopyala",
                    "SELECT-DEFAULT-LANGUAGE": "Varsayılan Dili Seç",
                    "SWITCH-MODE": "Mod Değiştir"
                },
                "LANGUAGE": {
                    "SEARCH": "Ara",
                    "ADDED": "Eklendi",
                    "DEFAULT": "Default",
                    "NOT-ADDED": "Eklenmedi",
                    "LANGUAGE-INFO-TEXT": "Yeni bir dil ekleyerek kullanıcılar için çoklu dil destekleyen bir Workflow oluşturun. Kullanıcılarınızın Workflow'u görüntülemesini tercih ettiğiniz dili varsayılan dil olarak ayarlayarak da değiştirebilirsiniz.",
                    "SELECT-LANGUAGE": "Dil Seçin",
                    "CHECK-LANGUAGE": "Otomatik çeviriden sonra değişiklikler yaptınız. Lütfen tüm dilleri kontrol etmeyi unutmayın!",
                    "DELETE-LANGUAGE-OR-NOT": "Dili silmek istediğinizden emin misiniz? Seçilen dildeki tüm içerik kaybolacak."
                },
                "DELETE": "Sil",
                "WORKFLOW-NOT-FOUND": "Bağlantıyla ilişkili Workflow bulunamadı",
                "SAVE-SUCCESSFUL": "Kaydetme başarılı",
                "SAVE-ERROR": "Kaydetme Hatası",
                "CLONED": "Başarıyla Klonlandı",
                "REPORT-SUBMITTED-BEFORE": "Rapor daha önce gönderildi"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Genel Erişimi Yönetin",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Erişimi silerek bu workflow'un paylaşımını durdurabilirsiniz.",
                "GENEATE-ACCESS-TEXT": "Bu workflow'a kolay erişim sağlamak için bağlantı ve QR kod oluşturabilirsiniz.",
                "ENABLE-PASSWORD": "Şifreyi etkinleştir",
                "GENERATE-ACCESS": "Oluştur",
                "LINK": "Bağlantı",
                "COPY": "Kopyala",
                "QR-CODE": "QR Kod",
                "DOWNLOAD": "İndir",
                "SECURITY": "Güvenlik",
                "PASSWORD-PROTECTED": "Şifre korumalı",
                "PUBLIC": "Şifre korumasız",
                "DELETE-ACCESS": "Erişimi Sil",
                "EASY-ACCESS-TITLE": "{{ shortName }} Workflow Kolay Erişim",
                "OPEN-WORKFLOW-NAME": "Açmak üzere olduğunuz workflow",
                "GUEST-EMAIL": "Misafir E-postası",
                "REQUIRED": "Bu alan zorunludur",
                "GUEST-PASSWORD": "Misafir Şifresi",
                "OPEN": "Aç",
                "OPEN-APP": "Daha iyi bir deneyim için bu workflow'u uygulamada açabilirsiniz.",
                "COPY-LINK-TEXT": "Uygulama başlatıldığında bu workflow'u açmak için bağlantıyı panoya kopyalayın.",
                "DOWNLOAD-APP": "UYGULAMAYI İNDİR",
                "DOWNLOAD-SMARTGLASSES-APP": "AKILLI GÖZLÜKLER İÇİN UYGULAMAYI İNDİR",
                "OR": "Veya",
                "CONTINUE-WITH-BROWSER": "Tarayıcı ile devam et",
                "PASSWORD-PROTECTED-TEXT": "Şifre etkinleştirildiğinde, linke veya QR koda sahip olan kullanıcılar yalnızca şifre girdikten sonra workflow'a erişebilir.",
                "CREATE-PASSWORD": "Şifre Oluştur",
                "ENTER-EMAIL": "E-posta giriniz",
                "ENTER-WORKFLOW-PASSWORD": "Workflow şifresi giriniz",
                "DELETE-QR-TEXT": "Kolay Erişim'in güvenlik türünü değiştirmek için Kolay Erişim'i silmeli ve yeniden oluşturmalısınız..",
                "LOADING-WORKFLOW": "Workflow yükleniyor...",
                "UNABLE-TO-LOAD": "Workflow Yüklenemedi",
                "RETRY": "Tekrar Dene",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "Token eksik veya geçersiz",
                    "ID-MISSING": "Workflow kimliği veya temel url eksik",
                    "WORKFLOW-NOT-PUBLISHED": "Workflow yayınlanmadı",
                    "PUBLIC-ACCESS": "Genel erişim zaten var",
                    "NO-PUBLIC-ACCESS": "Genel erişim yok"
                },
                "QR-INFORMATION": "QR Bilgileri"
            },
            "WORK-ORDERS": {
                "TITLE": "İş Emirleri",
                "CREATE-WORK-ORDER": "İş Emri Oluştur",
                "EDIT-WORK-ORDER": "İş Emri Düzenle",
                "EDIT": "Düzenle",
                "CREATE": "Oluştur",
                "DELETE": "Sil",
                "SAVE-CHANGES": "Kaydet",
                "TO-DO": "Yapılacaklar",
                "DONE": "Tamamlananlar",
                "EMPTY-LIST": "Hiç iş emri bulunamadı.",
                "SELECT-PRIORITY": "Öncelik",
                "PRIORITY": {
                    "high": "Yüksek",
                    "medium": "Orta",
                    "low": "Düşük"
                },
                "SELECT-STATUS": "Durum",
                "STATUS": {
                    "open": "Açık",
                    "in-progress": "Devam Ediyor",
                    "on-hold": "Beklemede",
                    "done": "Tamamlandı"
                },
                "SELECT-ASSIGNEE": "Atanan",
                "SELECT-LABEL": "Etiket",
                "SEARCH": "Ara",
                "SELECT-DUE-DATE": "Bitiş Tarihi",
                "NO-ITEMS-FOUND": "Öğe bulunamadı",
                "SELECT-RECURRENCE": "Tekrarlama",
                "RECURRENCE": {
                    "none": "Yok",
                    "daily": "Günlük",
                    "weekly": "Haftalık",
                    "monthly": "Aylık"
                },
                "ITEMS": {
                    "ID": "ID",
                    "PRIORITY": "Öncelik",
                    "DUE-DATE": "Bitiş tarihi",
                    "TASK-NAME": "Görev adı",
                    "STATUS": "Durum",
                    "ADD-DUE-TIME": "Bitiş zamanı ekle",
                    "CLEAR-DUE-TIME": "Bitiş zamanını sil",
                    "RECURRENCE": "Tekrarlama",
                    "DESCRIPTION": "Açıklama",
                    "FILES": "Dosyalar",
                    "ASSIGNED-WORKFLOWS": "Atanan Workflowlar",
                    "ADD-WORKFLOW": "Workflow ekle",
                    "ASSIGNED-TO": "Atanan Kişi",
                    "SELECT-USER": "Kişi Seç",
                    "ACTIVITY": "Aktivite"
                },
                "ACTIVITY": {
                    "dueDate": "due date",
                    "assignedTo": "assigned to",
                    "status": "status",
                    "priority": "priority",
                    "assignedExpert": "assigned expert",
                    "files": "files",
                    "labels": "labels",
                    "description": "description",
                    "name": "name",
                    "assignedWorkflows": "assigned workflows",
                    "recurrence": "recurrence",
                    "UPDATED": "updated the",
                    "WORK-ORDER-CREATED": "created the work order"
                },
                "WARNING": {
                    "DELETE-WORK-ORDER-TITLE": "İş Emrini Sil",
                    "DELETE-WORK-ORDER-TEXT": "Bu iş emrini silmek istediğinize emin misiniz?",
                    "UNASSIGN-WORKFLOW-TITLE": "Workflow'u Kaldır",
                    "UNASSIGN-WORKFLOW-TEXT": "Bu workflow'u kaldırmak istediğinize emin misiniz?"
                },
                "DETAILS": "Detaylar",
                "COMMENTS": "Yorumlar",
                "ASSIGNED-EXPERTS-FOR-REMOTE-CALL": "Uzaktan Yardım için Atanan Uzmanlar"
            },
            "TICKETS": {
                "TITLE": "Destek Talepleri",
                "NEW_TICKET": "Yeni Destek Talebi",
                "CREATE_TICKET": "Destek Talebi Oluştur",
                "EDIT_TICKET": "Destek Talebini Düzenle",
                "TICKET_DETAILS": "Destek Talebi Detayları",
                "TICKET_CREATED": "Destek talebi başarıyla oluşturuldu",
                "TICKET_UPDATED": "Destek talebi başarıyla güncellendi",
                "TICKET_DELETED": "Destek talebi başarıyla silindi",
                "DELETE_CONFIRM": "Bu destek talebini silmek istediğinizden emin misiniz?",
                "ALL_ROOMS": "Tüm Odalar",
                "ALL_CREATORS": "Tüm Oluşturanlar",
                "ALL_ASSIGNEES": "Tüm Atananlar",
                "ALL_STATUSES": "Tüm Durumlar",
                "ALL_PRIORITIES": "Tüm Öncelikler",
                "CREATED_BETWEEN": "Oluşturma Tarihi Aralığı",
                "NO_TICKETS": "Destek talebi bulunamadı",
                "TICKET_TITLE": "Başlık",
                "ROOM": "Oda",
                "WORK_GROUP": "Çalışma Grubu",
                "ALL_WORK_GROUPS": "Tüm Çalışma Grupları",
                "CREATED_BY": "Oluşturan",
                "CREATED_ON": "Oluşturma Tarihi",
                "STATUS": "Durum",
                "STATUS_OPEN": "Açık",
                "STATUS_IN_PROGRESS": "Devam Ediyor",
                "STATUS_CLOSED": "Kapalı",
                "STATUS_IN-PROGRESS": "Devam Ediyor",
                "STATUS_UPDATED": "Durum başarıyla güncellendi",
                "LOW": "Düşük",
                "MEDIUM": "Orta",
                "HIGH": "Yüksek",
                "PRIORITY_LOW": "Düşük",
                "PRIORITY_MEDIUM": "Orta",
                "PRIORITY_HIGH": "Yüksek",
                "TYPE": "Tür",
                "PRIORITY": "Öncelik",
                "DESCRIPTION": "Açıklama",
                "RESOLUTION": "Çözüm",
                "FOLLOWUP_DATE": "Takip Tarihi",
                "ASSIGNEE": "Atanan",
                "CREATE": "Oluştur",
                "SAVE": "Kaydet",
                "SAVE_CHANGES": "Değişiklikleri Kaydet",
                "CANCEL": "İptal",
                "DELETE": "Sil",
                "DELETED": "Başarıyla silindi",
                "DELETE_ERROR": "Silme işlemi başarısız oldu",
                "EDIT": "Düzenle",
                "TAB_ACTIVE": "Aktif",
                "TAB_CLOSED": "Kapalı",
                "UPDATE_SUCCESS": "Destek talebi başarıyla güncellendi",
                "CREATE_SUCCESS": "Destek talebi başarıyla oluşturuldu",
                "UPDATE_ERROR": "Güncelleme başarısız oldu",
                "CREATE_ERROR": "Oluşturma başarısız oldu",
                "LOAD_ERROR": "Destek talebi detayları yüklenemedi",
                "TITLE_REQUIRED": "Başlık gereklidir",
                "DESCRIPTION_REQUIRED": "Açıklama gereklidir",
                "FORM_INVALID": "Lütfen tüm gerekli alanları doldurun",
                "DETAILS": "Detaylar",
                "ATTACHED_SESSIONS": "Bağlantılı Oturumlar",
                "ADD_SESSION": "Oturum Ekle",
                "SESSION_COUNT": "Oturum Sayısı",
                "TOTAL_DURATION": "Toplam Süre",
                "PARTICIPANTS": "Katılımcılar",
                "DATE": "Tarih",
                "ROOM_NAME": "Çalışma Grubu",
                "DURATION": "Süre",
                "SESSIONS": "Oturum",
                "GUEST": "Misafir",
                "NO_SESSIONS": "Oturum bulunamadı",
                "NO_ATTACHED_SESSIONS": "Bağlantılı oturum yok",
                "DETACH_SESSION": "Oturumu Ayır",
                "DETACH_SESSION_CONFIRM": "Bu oturumu destek talebinden ayırmak istediğinizden emin misiniz?",
                "DETACH": "Ayır",
                "DETACH_SUCCESS": "Oturum başarıyla ayrıldı",
                "ATTACH_SUCCESS": "Destek talebi başarıyla değiştirildi",
                "SESSION_ALREADY_ATTACHED": "Bu oturum zaten başka bir destek talebine bağlı",
                "WORK_GROUP_CHANGE_WARNING": "Çalışma Grubunu Değiştir",
                "WORK_GROUP_CHANGE_CONFIRM": "Bu destek talebinde mevcut çalışma grubundan {{count}} adet bağlı oturum bulunmaktadır. Çalışma grubunu değiştirirseniz, tüm bu oturumlar otomatik olarak ayrılacaktır. Devam etmek istiyor musunuz?",
                "WORK_GROUP_CHANGE_CONFIRM_SINGULAR": "Bu destek talebinde mevcut çalışma grubundan 1 adet bağlı oturum bulunmaktadır. Çalışma grubunu değiştirirseniz, bu oturum otomatik olarak ayrılacaktır. Devam etmek istiyor musunuz?",
                "FILES": {
                    "TITLE": "Dosyalar",
                    "DOWNLOAD": "İndir",
                    "DOWNLOAD_STARTED": "İndirme başlatıldı",
                    "NO_FILES": "Dosya bulunamadı",
                    "UPLOAD_SUCCESS": "Dosya başarıyla yüklendi",
                    "UPLOAD_ERROR": "Dosya yüklenemedi"
                },
                "CHAT_TIMELINE": {
                    "TITLE": "Sohbet+Zaman Çizelgesi",
                    "EMPTY": "Henüz mesaj veya aktivite yok",
                    "PLACEHOLDER": "Mesaj yazın... Kullanıcı etiketlemek için @ kullanın",
                    "SEND": "Gönder",
                    "SEND_ERROR": "Mesaj gönderilemedi",
                    "ATTACH_FILE": "Dosya ekle",
                    "PASTE_UPLOAD_TITLE": "Dosya yükle",
                    "PASTE_UPLOAD_CONFIRM": "Panodan kopyalanan dosyayı yüklemek ister misiniz?",
                    "PASTE_UPLOAD_CONFIRM_BUTTON": "Yükle",
                    "SESSION_ATTACHED": "Uzaktan destek oturumu yapıldı",
                    "FILE_ADDED": "Dosya eklendi",
                    "UPLOADED_BY": "yükledi",
                    "TODAY": "Bugün",
                    "YESTERDAY": "Dün",
                    "SYSTEM": {
                        "DEFAULT_ACTOR": "Bir kullanıcı",
                        "STATUS_CHANGED": "{{ actor }} durumu {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "PRIORITY_CHANGED": "{{ actor }} önceliği {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "DATE_CHANGED": "{{ actor }} tarihi {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "ASSIGNEE_CHANGED": "{{ actor }} sorumluyu {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "ROOM_CHANGED": "{{ actor }} odayı {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "TYPE_CHANGED": "{{ actor }} tipi {{ from }} değerinden {{ to }} değerine değiştirdi.",
                        "TITLE_UPDATED": "{{ actor }} başlığı güncelledi.",
                        "DESCRIPTION_UPDATED": "{{ actor }} açıklamayı güncelledi.",
                        "RESOLUTION_UPDATED": "{{ actor }} çözümü güncelledi.",
                        "EXTRA_FIELDS_UPDATED": "{{ actor }} diğer alanları güncelledi."
                    }
                },
                "EXPORT_PDF": {
                    "BUTTON": "Dışa Aktar",
                    "TITLE": "Destek Talebi Dışa Aktar",
                    "SUBTITLE": "Rapor içinde hangi verilerin olacağını seçin.",
                    "ATTACHED_SESSIONS": "Bağlantılı Oturumlar",
                    "FILES": "Dosyalar",
                    "CHAT": "Sohbet",
                    "IMAGES_IN_PDF": "Görselleri PDF'e ekle",
                    "IMAGES_OPTIMIZED": "Görseller PDF boyutu için optimize edilir.",
                    "IMAGE_COMPRESSION_TOOLTIP": "Dosya boyutunu optimize etmek için görseller sıkıştırılabilir.",
                    "SECTION_INCLUDE": "DAHIL ET",
                    "SECTION_OUTPUT": "CIKTI",
                    "OUTPUT_FORMAT_LABEL": "Çıktı formatı:",
                    "OUTPUT_FORMAT_ZIP": "ZIP (PDF + ekler)",
                    "OUTPUT_FORMAT_PDF": "Sadece PDF",
                    "ESTIMATED_SIZE": "Tahmini dosya boyutu:",
                    "ZIP_NOTICE": "Dosyalar seçilirse PDF ve dosyalar ZIP olarak indirilecektir.",
                    "CANCEL": "İptal",
                    "EXPORT": "Raporu Dışa Aktar",
                    "EXPORTING": "Oluşturuluyor...",
                    "MIN_SELECTION": "En az bir seçenek seçin.",
                    "DETAILS_TITLE": "Detaylar",
                    "SESSIONS_TITLE": "Bağlantılı Oturumlar",
                    "FILES_TITLE": "Dosyalar",
                    "CHAT_TITLE": "Sohbet+Zaman Çizelgesi",
                    "NO_ITEMS": "Veri yok",
                    "FILE_TYPE": "Tür",
                    "FILE_SIZE": "Boyut",
                    "FILE_UPLOADER": "Yükleyen",
                    "CHAT_TIME": "Zaman",
                    "CHAT_USER": "Gönderen",
                    "CHAT_MESSAGE": "Mesaj",
                    "SESSION_HELD": "Uzaktan destek oturumu yapıldı",
                    "FILE_SHARED": "Dosya paylaşıldı: {{ file }}",
                    "FILE_SHARED_BY": "Dosya paylaştı: {{ file }}"
                }
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Video Akışları",
                "CREATE-VIDEO-FLOW": "Video Akışı Oluştur",
                "CREATED-BY-AI": "AI Tarafından Oluşturuldu",
                "VERSION": "Versiyon",
                "NO-VIDEO-FLOWS-FOUND": "Hiç video akışı bulunamadı",
                "CLEAR-ALL": "Hepsini Temizle",
                "CONFIRM-VIDEO": "Videoyu Onayla",
                "CONFIRM-VIDEO-TITLE": "Video Dönüşümünü Onayla",
                "CONFIRM-VIDEO-MESSAGE": "Bu video akışını workflow'a dönüştürmek istediğinizden emin misiniz? Onayladıktan sonra videoyu düzenleyemeyeceksiniz.",
                "CONFIRM-VIDEO-BUTTON": "Onayla ve Dönüştür",
                "MAKE-WORKFLOW-SUCCESSFUL": "Workflow'a dönüştürüldü",
                "MAKE-WORKFLOW-ERROR": "Workflow'a dönüştürme başarısız",
                "UPLOAD-VIDEO-DESCRIPTION": "Videonuzu yükleyerek otomatik olarak adım adım bir workflow rehberi oluşturun.",
                "VIDEO-DURATION-LIMIT": "Video süresi 30 dakikayı aşamaz.",
                "VIDEO-UPLOADED-SUCCESS": "Video başarıyla yüklendi!",
                "SELECT-VIDEO": "Video Seç",
                "CHANGE-VIDEO": "Videoyu Değiştir",
                "CREATE-BUTTON": "Oluştur",
                "AI-PROCESSING": "AI işleme devam ediyor",
                "SPLITTING-VIDEO": "Video bölümlere ayrılıyor",
                "TRANSCRIBING-VIDEO": "Video içeriği transkript ediliyor",
                "PROCESS-WARNING": "Bu işlem 10 dakikaya kadar sürebilir. Lütfen bu pencereyi kapatmayın."
            }
        },
        "NAVBAR": {
            "LOGOUT": {
                "TEXT": "Çıkış Yap",
                "TEXT-MESSAGE": {
                    "MESSAGE": "Çıkış yapmak istediğinizden emin misiniz?",
                    "CONFIRM": "Çıkış Yap"
                }
            }
        },
        "CALL_MESSAGE": {
            "TITLE": "<strong>{{ caller_name }}</strong> tarafından gelen arama",
            "DENY": "Reddet",
            "ACCEPT": "Kabul Et"
        },
        "SIDEBAR": {
            "WORKFLOWS": "Workflowlar",
            "USERS": "Kullanıcılar",
            "REPORTS": "Raporlar",
            "DRAFTS": "Raporlar",
            "ANALYTICS": "Analitik",
            "SETTINGS": "Ayarlar",
            "SWITCH-ADMIN-PANEL": "Editöre geç",
            "SWITCH-USER-PANEL": "Kullanıcı paneline geç",
            "SWITCH-ADMIN-PANEL-TEXT": "Workflowları oluşturmak ve düzenlemek için Kullanıcı panelinden Editöre geçin.",
            "SWITCH-USER-PANEL-TEXT": "Workflowları tamamlamak için Editörden Kullanıcı paneline geçin.",
            "WORK-ORDERS": "İş Emirleri",
            "TICKETS": "Destek Talepleri",
            "REMOTE-ASSISTANCE": "Uzaktan Yardım",
            "VIDEO-FLOWS": "Video Akışları"
        },
        "USER-WORKFLOW": {
            "ADD": "EKLE",
            "INVALID-EMAIL": "Geçersiz e-posta",
            "SEND-REQUEST": "Onaya gönder:",
            "SEND-REPORT": "Raporu gönder:",
            "REMOVE": "SİL",
            "APPROVAL-REQUEST": "Onay Talebi",
            "REQUEST-SENDED-TEXT": "Onay talebiniz listelenen e-posta adreslerine başarıyla gönderildi.",
            "CLOSE": "KAPAT",
            "LICENCE-LIMIT": "Hesabınız maksimum workflow gönderimi sayısına ulaştı. Hesap yöneticisi, lisans yükseltildikten sonra raporu görecektir.",
            "REQUEST-PENDING": "Onay Talebi Beklemede",
            "REQUEST-APPROVAL": "Rapor İçin Onay Talebi",
            "REQUEST-REPORT": "Onaydan sonra rapor gönder",
            "SEND-REQUEST-TITLE": "ONAYA GÖNDER",
            "SEND-REPORT-TITLE": "RAPOR GÖNDER",
            "TASK-TO-COMPLETE": "Tamamlanacak Adım Sayısı:",
            "SELECT-LANGUAGE": "Dil Seçin",
            "CONTENT-LANGUAGE": "Workflow İçerik Dili:",
            "ESTIMATED-DURATION": "Tahmini Süre:",
            "DELETE": "Sil",
            "DELETE-APPROVAL": "Silmek istediğinizden emin misiniz?",
            "EMAIL-INVALID": "E-posta formatı geçersiz",
            "MISSING-EQUIPMENT": "Eksik Ekipman",
            "PROTECTED-EQUIPMENT": "Lütfen gerekli kişisel korumalı ekipmanları kullanın",
            "CONTINUE-WITH-QR-WARNING-TEXT": "Önceden doldurulmuş iş akışınızı göndermek üzeresiniz. Önceden doldurulmuş iş akışına daha sonra erişilmesi ve devam ettirilmesi için bir bağlantı ve QR kodu oluşturulur. QR kodu oluşturulduktan sonra, önceden doldurulan adımlar düzenlenemez. Devam etmek istediğinizden emin misiniz?",
            "CONTINUE-WITH-QR-TITLE": "Önceden doldurulmuş iş akışını gönderme",
            "TABLE-OF-CONTENTS": "Workflow adımları",
            "CALL-EXPERT": "Uzman ara",
            "HAND-OVER": "Devret",
            "CANCEL": "İPTAL",
            "CALL": "ARA",
            "SAVE-CHANGES": "Kaydet",
            "CALL-PERMISSION-WARNING": "Arama izniniz yok. Lütfen sistem yöneticinize başvurun.",
            "SELECT-EXPERT-TEXT": "Aramak istediğiniz uzmanı seçin:",
            "ERRORS": {
                "INTEGRATION-NOT-FOUND": "Entegrasyon bulunamadı"
            },
            "QR-NOT-MATCHED": "QR kod eşleşmedi",
            "STEP-FILES": {
                "TITLE": "DOSYALAR"
            }
        },
        "LOBBY": {
            "LOBBY_SHARED": {
                "ONGOING_CALLS_TITLE": "Devam Eden Aramalar",
                "ROOMS_TITLE": "Odalarınız",
                "UPCOMING_MEETINGS_TITLE": "Gelecek Toplantılar",
                "PREVIOUS_MEETINGS_TITLE": "Geçmiş Toplantılar",
                "SCHEDULE_MEETING": "Toplantı Planla",
                "INSTANT_GUEST_ACCESS": "Hızlı Misafir Erişimi",
                "INSTANT_GUEST_ACCESS_NO_CALLING": "Arama yapma izniniz yok. Lütfen yöneticinizle iletişime geçin.",
                "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Misafir erişim bağlantısı oluşturma izniniz yok. Lütfen yöneticinizle iletişime geçin.",
                "INSTANT_GUEST_ACCESS_NO_PERM": "Arama yapma ve misafir erişim bağlantısı oluşturma izniniz yok. Lütfen yöneticinizle iletişime geçin.",
                "LINK_UNAVAILABLE": "Bağlantı kullanılamıyor",
                "JOIN": "KATIL",
                "CANCEL": "İPTAL",
                "REMOVE": "KALDIR",
                "NO_ROOM": "Oda listeniz boş.",
                "NO_MEETING": "Toplantınız yok.",
                "NO_PREV_MEETING": "Toplantınız yok.",
                "NO_OTHER_USERS": "Başka kullanıcı yok.",
                "SHOW_MORE": "{{ count }} tane daha",
                "SHOW_LESS": "gizle",
                "REMOTE_ASSISTANCE": "Uzaktan Yardım",
                "NEW_REMOTE_SESSION": "Yeni Uzaktan Yardım Oturumu",
                "START_INSTANT_CALL": "Hızlı Arama Başlat",
                "OVERVIEW": "Genel Bakış",
                "MEETINGS": "Toplantılar",
                "WORK_GROUPS": "Çalışma Grupları",
                "HISTORY": "Geçmiş",
                "JOIN_REMOTE_SESSION": "Uzaktan Yardım Oturumuna Katıl",
                "JOIN_REMOTE_SESSION_DESCRIPTION": "Planlanmış bir toplantıya katılmak için paylaşılan bir bağlantı girin.",
                "ENTER_LINK_PLACEHOLDER": "Bağlantıyı Girin",
                "JOIN_BUTTON": "Katıl",
                "UPCOMING_SCHEDULED_MEETINGS": "Yaklaşan Planlı Toplantılar",
                "VIEW_ALL_MEETINGS": "Tüm Toplantıları Görüntüle"
            },
            "SCHEDULE_MEETING_MODAL": {
                "TITLE": "Toplantı Planla",
                "MEETING_TITLE": "Başlık*",
                "MEETING_TITLE_REQUIRED": "Başlık gerekli.",
                "START_DATE": "Başlangıç",
                "END_DATE": "Bitiş",
                "CLOSE": "Kapat",
                "SCHEDULE_SEND": "Planla ve Gönder",
                "SCHEDULE": "Planla",
                "CANNOT_SCHEDULE": "Toplantı planlarken bir hata oluştu.",
                "CANNOT_CANCEL_MEETING": "Toplantıyı iptal ederken bir hata oluştu.",
                "ENTER_USERS": "Kullanıcıları giriniz",
                "SEND_INVITATIONS": "Davetiye gönder",
                "INVITATION_EMAIL_LANG": "Davet e-postası dili",
                "SHARE_AFTER": "Toplantı bağlantısı, toplantı planlandıktan sonra da paylaşılabilir."
            },
            "CANCEL_MEETING_MODAL": {
                "CANCEL_TITLE": "Toplantıyı İptal Et",
                "REMOVE_TITLE": "Toplantıyı Kaldır",
                "CANCEL_MESSAGE": "Toplantıyı iptal etmek istediğinizden emin misiniz?",
                "REMOVE_MESSAGE": "Toplantıyı kaldırmak istediğinizden emin misiniz?",
                "CLOSE": "Kapat",
                "PROCEED": "Devam Et"
            },
            "CONTACTS": {
                "TITLE": "Kişiler",
                "NO_CONTACT": "Kişi listeniz boş.",
                "NO_PERMISSION": "Kişi listesini görme ve arama izniniz yok.",
                "SELECT_MULTI": "Çoklu Seçim",
                "CALL": "Ara",
                "ADMIN": "Yönetici",
                "COADMIN": "Yardımcı-Yönetici",
                "EXPERT": "Uzman",
                "SUBSCRIBER": "Kullanıcı",
                "USER": "Kullanıcı",
                "NAME": "Ad",
                "USERNAME": "Kullanıcı Adı",
                "ROLE": "Rol",
                "NO_EXPERT": "Lütfen arama yapmak için en az bir uzman seçin.",
                "NAME_USERNAME": "Isim ya da Kullanıcı Adı",
                "ALL_ROLES": "Tüm Roller",
                "SEARCH_PLACEHOLDER": "İsim ara",
                "INSTANT_CALL_DESCRIPTION": "Bir kullanıcıyla hızlı bir arama yapın veya grup araması yapmak için birden fazla kullanıcı seçin."
            },
            "SESSIONS": {
                "TITLE": "Oturumlar",
                "DATE": "Oluşturulma Tarihi",
                "DURATION": "Süre",
                "ROOM_NAME": "Oda",
                "NO_SESSIONS": "Session listesi boş.",
                "PARTICIPANTS": "Katılımcılar",
                "EXPORT": "Dışa Aktar",
                "STATUS": "Durum",
                "ON_GOING": "Devam Ediyor",
                "ENDED": "Sonlandı",
                "FILES": "Dosyalar",
                "CHAT": "Chat",
                "SESSION_FILES": {
                    "MULTIPLE_SELECTION": "Çoklu Seçim",
                    "DOWNLOAD": "İndir",
                    "DOWNLOAD_STARTED_SOON": "İndirme kısa süre içinde başlayacak.",
                    "DOWNLOAD_FAILED": "indirme hatası",
                    "NO_FILE_IS_ADDED": "Bu oturumda hiçbir dosya bulunmamaktadır.",
                    "SUCCESS_MESSAGE": "Dosyalar başarıyla indirildi."
                },
                "ATTACHED_TICKET": "Eklenen Ticket",
                "SESSION_DETAILS": "Oturum Detayları",
                "BACK": "Geri",
                "GET_SESSION_EXPORT": "Oturumu Dışa Aktar",
                "ATTACH_TO_TICKET": "Ticket Ekle",
                "MORE": "daha fazla"
            },
            "ARCHIVES": {
                "ARCHIVE_LIST": {
                    "REFRESH": "Yenile",
                    "LOADING": "Video kayıtları yükleniyor",
                    "NO_ARCHIVE_MESSAGE": "Video kaydı bulunmamaktadır",
                    "NAME": "Ad",
                    "CREATED_AT": "Oluşturulma Tarihi",
                    "STORAGE": "Storage",
                    "DURATION": "Süre",
                    "ARCHIVES": "Video Kayıtları",
                    "SIZE": "Dosya büyüklüğü",
                    "STATUS": "Durum",
                    "AVAILABLE": "Kullanılabilir",
                    "DISCONNECTED": "bağlantı kesildi",
                    "DELETED": "silindi",
                    "EXPIRED": "süresi doldu",
                    "WAITING": "bekliyor",
                    "FAILED": "başarısız",
                    "DOWNLOAD": "İndir",
                    "PLAY": "Oynat",
                    "DELETE": "Sil",
                    "DOWNLOAD_ARCHIVE": {
                        "TITLE": "Kaydı İndir",
                        "GENERATING": "Oluşturuluyor",
                        "GENERATED": "Oluşturuldu",
                        "CANNOT_GENERATED": "Oluşturulamıyor.",
                        "DOWNLOAD": "İndir",
                        "CLOSE": "Kapat"
                    },
                    "DELETE_ARCHIVE": {
                        "TITLE": "Kaydı Sil",
                        "MESSAGE": "Video kaydı silinecektir.",
                        "CAUTION": "DİKKAT: Bu kayıt, Azure depolama alanınızdan da silinecek.",
                        "CANCEL": "İptal",
                        "DELETE": "Sil"
                    }
                }
            },
            "CONVERTER": {
                "TITLE": "Dönüştürücü",
                "STP_ONLY": "Yalnızca .stp ve .step dosya biçimleri desteklenir.",
                "ERROR_UPLOAD": "Dosya yüklenirken bir hata oluştu.",
                "DRAG": "Dosyanızı buraya sürükleyip bırakın",
                "OR": "veya",
                "CHOOSE": "Dosya seçin",
                "CONVERT": "Dönüştür",
                "SUPPORTED": "Desteklenen Dosya Formatları:",
                "BACK": "Geri",
                "DOWNLOAD": "İndir",
                "ERROR_LOAD": "Nesne yüklenirken bir hata oluştu."
            },
            "WHATSNEW": {
                "WHATSNEW_TITLE": "Yenilikler",
                "NO_UNREAD_UPDATE": "Görülmemiş güncelleme yok"
            },
            "JOIN_MODAL": {
                "JOIN": "KATIL",
                "CALL": "ARA",
                "CANCEL": "İPTAL",
                "MIRROR_VIDEO": "Görüntüyü Ters Çevir",
                "PREFERRED_RESOLUTION": "Tercih Edilen Çözünürlük",
                "RESOLUTION_NOTE": "Not: Cihazınız tercih ettiğiniz çözünürlüğü desteklemiyorsa, bir sonraki en yüksek çözünürlük kullanılacaktır.",
                "CAM_MIC_PERM_REQUIRED": "Kamera ve mikrofon izni gerekiyor",
                "CAM_MIC_PERM_DENIED": "Kamera veya mikrofon erişimi engellendi",
                "CAM_MIC_CANT_ACCESS": "Kamera veya mikrofonunuza erişemiyoruz",
                "JOIN_CAM_OFF": "Kamera kapalı katıl",
                "JOIN_MIC_OFF": "Mikrofon kapalı katıl",
                "JOIN_CAM_MIC_OFF": "Kamera ve Mikrofon kapalı katıl",
                "JOIN_NO_DEVICE": "Kamera ve mikrofon olmadan katıl",
                "ALLOW_ACCESS": "Tarayıcı ayarlarınızda kameranıza ve mikrofonunuza erişime izin vermeniz gerekir (Erişim izni verdikten sonra, kameranızı veya mikrofonunuzu yine de kapatabilirsiniz).",
                "TRY_AGAIN": "Sayfayı yenileyin ve tarayıcınız tarafından izin istendiğinde 'İzin Ver'i seçin."
            },
            "NO_DEVICE_MODAL": {
                "TITLE": "Aygıt bulunamadı",
                "JOIN_BODY": "Bu cihaza bağlı mikrofon veya kamera yok. Diğer kullanıcılar sizi bu cihazdan duyamaz veya göremez. Yine de katılmak istiyor musunuz?",
                "CALL_BODY": "Bu cihaza bağlı mikrofon ve kamera yok. Diğer kullanıcılar sizi bu cihazdan duyamaz veya göremez. Yine de aramak istiyor musunuz?",
                "CANCEL": "İptal",
                "JOIN": "Yine de Katıl",
                "CALL": "Yine de Ara"
            },
            "AGREEMENT_MODAL": {
                "TITLE": "Kişisel Verilerin İşlenmesi ve Güvenliği Onay Formu",
                "REJECTION_BUTTON": "Reddet",
                "AGREEMENT_BUTTON": "Kabul Et"
            },
            "CHECK_AGREEMENT_MODAL": {
                "TITLE": "Sözleşmeyi redded?",
                "ERROR": "Bir hata oluştu.",
                "STATEMENT": "Sözleşmeyi kabul etmediğinizde sisteme giriş yapamayacaksınız.",
                "CANCEL_BUTTON": "Geri Dön",
                "PROCEED_BUTTON": "Devam Et"
            },
            "JOIN_UNKNOWN_ERROR": "Odaya giriş yapılırken bir hata oluştu.",
            "JOIN_CONCURRENT_ERROR": "Eş zamanlı kullanıcı limitine ulaştınız. Daha fazla bilgi için yönetici ile iletişime geçin.",
            "JOIN_EXPERT_CONCURRENT_ERROR": "Eş zamanlı uzman kullanıcı limitine ulaştınız. Daha fazla bilgi için yönetici ile iletişime geçin.",
            "NO_TRAINING_LICENSE": "Eğitim odası lisansınızla ilgili bir sorun var. Lütfen yöneticinize başvurun.",
            "TRAINING_LICENSE_EXPIRED": "Eğitim odası lisansınızın süresi doldu. Lütfen yöneticinize başvurun.",
            "ASK_TRAINING_HOST": "Eğitim odasına giriş yapılırken bir hata oluştu. Lütfen yöneticiye başvurun.",
            "JOIN_CALL_IN_PROGRESS": "Kişisel toplantı odanızda başka bir görüşme var.",
            "NOT_SUPPORTED_TITLE": "Uyumsuz tarayıcı",
            "NOT_SUPPORTED_MESSAGE": "Tarayıcınız uyumlu değil. Lütfen Google Chrome, Mozilla Firefox, Safari veya Microsoft Edge (versiyon 79 ve üstü) kullanınız.",
            "NO_IOS_MESSAGE": "Tarayıcınız uyumlu değil. Lütfen {{ appName }} Remote uygulamasını indirin veya Safari kullanın.",
            "IOS_VERSION_MESSAGE": "Tarayıcınız uyumlu değil. Lütfen {{ appName }} Remote uygulamasını indirin.",
            "NOT_SUPPORTED_CLOSE": "Kapat",
            "IDLE_MODAL_TITLE": "Hata",
            "IDLE_MODAL_MESSAGE": "Uzun süredir işlem yapmadınız.",
            "IDLE_MODAL_COUNT": "{{ count }} saniye içerisinde ana sayfaya yönlendirileceksiniz.",
            "IDLE_MODAL_OK": "Buradayım",
            "ARCHIVE_PERMISSION_MODAL": {
                "TITLE": "Video Kaydına İzin Ver?",
                "MESSAGE": "Bu odadaki görüşme kaydedilecektir. Bu odaya katılabilmek için video kaydına izin vermeniz gerekiyor.",
                "DENY": "Reddet",
                "ALLOW": "İzin Ver"
            }
        },
        "ARCHIVES": {
            "ARCHIVE_LIST": {
                "REFRESH": "Yenile",
                "LOADING": "Video kayıtları yükleniyor",
                "NO_ARCHIVE_MESSAGE": "Video kaydı bulunmamaktadır",
                "NAME": "Ad",
                "CREATED_AT": "Oluşturulma Tarihi",
                "STORAGE": "Storage",
                "DURATION": "Süre",
                "ARCHIVES": "Video Kayıtları",
                "SIZE": "Dosya büyüklüğü",
                "STATUS": "Durum",
                "AVAILABLE": "Kullanılabilir",
                "DISCONNECTED": "bağlantı kesildi",
                "DELETED": "silindi",
                "EXPIRED": "süresi doldu",
                "WAITING": "bekliyor",
                "FAILED": "başarısız",
                "DOWNLOAD": "İndir",
                "PLAY": "Oynat",
                "TRANSCRIBE": "Transkript Al",
                "TRANSCRIBING": "Transkript alınıyor",
                "VIEW_TRANSCRIPT": "Transkript",
                "RETRY_TRANSCRIPTION": "Transkripti yeniden dene",
                "TRANSCRIPTION": "Transkript",
                "TRANSCRIPTION_FAILED": "Transkript alınamadı",
                "NO_TRANSCRIPT": "Bu kayıtta konuşma algılanmadı.",
                "NO_TRANSCRIPT_HINT": "Kayıt başarıyla işlendi ancak burada gösterilecek konuşma içeriği bulunamadı.",
                "LANGUAGE": "Dil",
                "FULL_TEXT": "Tam metin",
                "SPEAKERS": "konuşmacı",
                "SEGMENTS": "segment",
                "DELETE": "Sil",
                "DOWNLOAD_ARCHIVE": {
                    "TITLE": "Kaydı İndir",
                    "GENERATING": "Oluşturuluyor",
                    "GENERATED": "Oluşturuldu",
                    "CANNOT_GENERATED": "Oluşturulamıyor.",
                    "DOWNLOAD": "İndir",
                    "CLOSE": "Kapat"
                },
                "DELETE_ARCHIVE": {
                    "TITLE": "Kaydı Sil",
                    "MESSAGE": "Video kaydı silinecektir.",
                    "CAUTION": "DİKKAT: Bu kayıt, Azure depolama alanınızdan da silinecek.",
                    "CANCEL": "İptal",
                    "DELETE": "Sil"
                },
                "GENERATING": "Oluşturuluyor...",
                "PLEASE_WAIT": "Lütfen bekleyin...",
                "WEBDAV": "WEBDAV"
            }
        },
        "ROOMS": {
            "ROOM_DETAILS": {
                "BACK": "Geri",
                "TITLE_NEW": "Yeni Çalışma Grubu",
                "TITLE_DETAILS": "Çalışma Grubu Detayları",
                "TITLE_EDIT": "Çalışma Grubunu Düzenle",
                "ROOM_DISABLED": "ÇALIŞMA GRUBU DEVRE DIŞI",
                "EDIT": "Düzenle",
                "RESET": "Sıfırla",
                "REVERT": "Geri Al",
                "CANCEL": "İptal",
                "ICON": "Simge",
                "CHOOSE_FILE": "Dosya Seç...",
                "ROOM_NAME": "Çalışma Grubu Adı",
                "TECHNICAL_DRAWING": "Teknik Çizim",
                "HAND_TOOLS": "Eldivenler",
                "FINISHED_PRODUCT": "Tamamlanmış Ürün",
                "VIDEO": "Video",
                "ROOM_NAME_REQUIRED": "Çalışma grubu adı gereklidir",
                "ROOM_NAME_LENGTH": "Çalışma grubu adı uzunluğu 1-60 karakter arasında olmalıdır",
                "DESCRIPTION": "Açıklama",
                "DESCRIPTION_REQUIRED": "Açıklama gereklidir.",
                "DESCRIPTION_LENGTH": "Açıklama uzunluğu 1-100 karakter arasında olmalıdır.",
                "USERS": "Kullanıcılar",
                "SELECT_USERS": "Kullanıcı Seç",
                "SAVE": "KAYDET",
                "ROOM_UPDATED": "Çalışma grubu başarıyla güncellendi.",
                "CANNOT_UPDATE": "Çalışma grubunu güncelleyemezsiniz.",
                "ROOM_CREATED": "Çalışma grubu oluşturuldu.",
                "CANNOT_CREATE": "Çalışma grubu oluşturulamadı.",
                "ALWAYS_ARCHIVE_ON": "Tüm oturumlar çalışma gruplarında hesabınızda kaydedilmektedir. Bunu ayarlardan değiştirebilirsiniz.",
                "ARCHIVE_UNAVAILABLE": "Lisansınızda video görüşme kaydetme özelliği yoktur.",
                "PEER_TO_PEER_NO_ARCHIVE": "Peer-to-Peer çalışma gruplarında kayıt yapılamaz.",
                "AUTO_ARCHIVE": "Bu çalışma grubundaki video görüşmelerini otomatik olarak kaydet",
                "ARCHIVE_PERMISSION_NEEDED": "Kayda başlamak için tüm kullanıcıların izni gereklidir.",
                "PEER_TO_PEER": "Video görüşmelerini Peer-to-Peer yap",
                "WHAT_IS_PEER_TO_PEER": "(P2P Nedir?)",
                "PEER_TO_PEER_UNAVAILABLE": "Lisansınızda Peer-to-Peer özelliği yoktur.",
                "FULL_HD": "Desteklenen mobil cihazlarda akış/örnekleme kalitesini FullHD yap",
                "FULL_HD_DISADVANTAGES": "Lütfen bu seçeneği katılımcıların internet bağlantısı kararlı olduğunda kullanın. Ayrıca, bu seçeneğin mobil cihazlarda daha fazla enerji ve veri tüketebileceğini ve bağlantı sorunlarına yol açabileceğini unutmayın.",
                "ALWAYS_FULL_HD_ON": "Tüm çalışma grupları için mobil cihazlarda akış/örnekleme kalitesi FullHd'dir. Bunu ayarlardan değiştirebilirsiniz.",
                "FULL_HD_UNAVAILABLE": "Lisansınızda FullHD özelliği yoktur.",
                "TRAINING_ROOM_NO_PEER_TO_PEER": "Peer-to-Peer akademi çalışma grupları için kullanılamaz.",
                "TRAINING_ROOM": "Akademi Çalışma Grubu",
                "TRAINING_LICENSE": "Akademi Çalışma Grubu Lisansı",
                "TRAINING_LICENSE_REQUIRED": "Akademi çalışma grubu lisansı gereklidir.",
                "TRAINING_MASTER": "Akademi Çalışma Grubu Host'u",
                "TRAINING_MASTER_REQUIRED": "Akademi çalışma grupları için host gereklidir.",
                "TRAINING_ROOM_UNAVAILABLE": "Lisansınızda akademi çalışma grubu özelliği yoktur.",
                "WHAT_IS_P2P": {
                    "TITLE": "Peer-to-Peer Nedir?",
                    "BETWEEN_CLIENTS": "İstemciler, ses-görüntü akışlarını doğrudan birbirlerine gönderir.",
                    "REDUCED_LATENCY": "Peer-to-Peer seçeneği, azaltılmış gecikme süresi avantajını sunar.",
                    "ARCHIVE_UNAVAILABLE": "Peer-to-Peer oturumu, oturumda yer alan katılımcılar arasında doğrudan bağlantı kurulduğu için kaydedilemez.",
                    "CLOSE": "Kapat"
                },
                "ENABLE_ROOM": "ÇALIŞMA GRUBUNU ETKİNLEŞTİR",
                "DISABLE_ROOM": "ÇALIŞMA GRUBUNU DEVRE DIŞI BIRAK",
                "TOGGLE_ROOM_MODAL": {
                    "TITLE_ENABLE": "Çalışma Grubunu Etkinleştirmek İstiyor Musunuz?",
                    "TITLE_DISABLE": "Çalışma Grubunu Devre Dışı Bırakmak İstiyor Musunuz?",
                    "MESSAGE_ENABLE": "Çalışma grubunu <strong>{{name}}</strong> etkinleştirmek istediğinize emin misiniz?",
                    "MESSAGE_DISABLE": "Çalışma grubunu <strong>{{name}}</strong> devre dışı bırakmak istediğinize emin misiniz?",
                    "CANCEL": "İptal",
                    "ENABLE": "Etkinleştir",
                    "DISABLE": "Devre Dışı Bırak",
                    "ENABLED": "Çalışma grubu etkinleştirildi.",
                    "DISABLED": "Çalışma grubu devre dışı bırakıldı.",
                    "ERROR": "Çalışma grubu durumu değiştirilemez."
                },
                "DELETE_ROOM": "ÇALIŞMA GRUBUNU SİL",
                "DELETE_ROOM_MODAL": {
                    "TITLE": "Çalışma Grubunu Sil?",
                    "MESSAGE": "Çalışma grubunu <strong>{{name}}</strong> silmek istediğinize emin misiniz?",
                    "CANCEL": "İptal",
                    "DELETE": "Sil",
                    "DELETED": "Çalışma grubu silindi.",
                    "ERROR": "Çalışma grubu silinemedi."
                },
                "CHANGE_AUTO_ARCHIVE_MODAL": {
                    "TITLE": "Çalışma Grubu Değişikliklerini Kaydet",
                    "MESSAGE_START": "Değişiklikler ",
                    "AUTO_ARCHIVE": "otomatik video çağrı kaydı",
                    "AND": " ve ",
                    "PEER_TO_PEER": "Peer-to-Peer",
                    "MESSAGE_END": " sonraki oturumlara uygulanacaktır.",
                    "CAUTION": "DİKKAT: Peer-to-Peer etkinleştirildiğinde kayıt yapılamaz.",
                    "TRAINING_CAUTION": "Bu çalışma grubu akademi çalışma grubuna (veya tersine) dönüştürüldüğünde, bu çalışma grubundaki herkes çıkarılacaktır.",
                    "CANCEL": "İptal",
                    "SAVE": "Kaydet"
                },
                "CREATE_WORK_GROUP": "Çalışma Grubu Oluştur",
                "EDIT_WORK_GROUP_DETAILS": "Çalışma Grubu Ayrıntılarını Düzenle",
                "ENABLE_WORK_GROUP": "Çalışma Grubunu Etkinleştir",
                "DISABLE_WORK_GROUP": "Çalışma Grubunu Devre Dışı Bırak",
                "DELETE_WORK_GROUP": "Çalışma Grubunu Sil",
                "UPLOAD_IMAGE": "Görüntü Yükle"
            },
            "ROOM_LIST": {
                "TITLE": "Çalışma Grupları",
                "NO_ROOM_MESSAGE": "Çalışma grubu listesi boş",
                "NEW_ROOM": "Yeni Çalışma Grubu",
                "ICON": "Simge",
                "ROOM_NAME": "Çalışma Grubu Adı",
                "DISABLED": "Devre Dışı",
                "USERS": "Kullanıcılar",
                "ACTIVE": "Aktif",
                "PASSIVE": "Pasif",
                "DETAILS": "Ayrıntılar",
                "EDIT": "Düzenle",
                "DELETE": "Sil",
                "DISABLE": "Devre Dışı Bırak",
                "ENABLE": "Etkinleştir",
                "ROOM_LIMIT_REACHED": "Maksimum çalışma grubu limiti aşıldı.",
                "GUEST": "Misafir",
                "ALL_USERS": "Tüm Kullanıcılar"
            }
        },
        "SETTINGS": {
            "WEBHOOKS": {
                "TITLE": "Webhooklar",
                "NEW_WEBHOOK": "Webhook Ekle",
                "NO_WEBHOOK": "Webhook listesi boş",
                "EVENT": "Olay",
                "URL": "URL",
                "REMOVE": "Kaldır",
                "ERROR": "Bir hata oluştu.",
                "API_ERROR": "Test bildirimi başarısız oldu.",
                "ADD_WEBHOOK_MODAL": {
                    "TITLE": "Webhook Ekle",
                    "PLACEHOLDER": "https://",
                    "WARNING": "Test bildirimi, yeni bir webhook eklenirken gönderilecektir.",
                    "AUTH": "Kimlik Doğrulama",
                    "KEY": "Anahtar",
                    "VALUE": "Değer",
                    "KEY_PLACEHOLDER1": "örneğin, token",
                    "VALUE_PLACEHOLDER1": "örneğin, eyJhbGci...",
                    "KEY_PLACEHOLDER2": "örneğin, Authorization",
                    "VALUE_PLACEHOLDER2": "örneğin, Bearer eyJhbGci...",
                    "SHOW_EXAMPLE": "Örnek Bildirimi Göster",
                    "FORM_WARNING": "Lütfen tüm alanları doldurun",
                    "CANCEL": "İptal",
                    "ADD": "Ekle",
                    "NONE": "Yok",
                    "TOKEN_BASED_BODY": "Token tabanlı (istek gövdesinde)",
                    "TOKEN_BASED_HEADER": "Token tabanlı (başlıkta)",
                    "EXAMPLE_NOTIFICATION": "Örnek Bildirim"
                },
                "REMOVE_WEBHOOK_MODAL": {
                    "TITLE": "Webhook'ı Kaldır?",
                    "MESSAGE": "Webhook'ı kaldırmak istediğinizden emin misiniz?",
                    "REMOVE": "Kaldır",
                    "CANCEL": "İptal"
                },
                "SAVE": "Kaydet"
            },
            "TABS": {
                "GENERAL": "Genel",
                "INTEGRATIONS": "Entegrasyonlar",
                "LICENSE": "Lisans",
                "TICKET": "Ticket"
            },
            "ARCHIVE": {
                "TITLE": "Video Görüşme Kayıt Ayarları",
                "ROOMS": "Çalışma Grupları",
                "RECORD_STATUS": "Kayıt Durumu",
                "AUTO": "Otomatik",
                "P2P": "P2P",
                "MANUAL": "Manuel",
                "AUTO_RECORD": "Tüm Çalışma Gruplarını Otomatik Olarak Kaydet",
                "CHANGE_INDIVIDUALLY": "Çalışma grubu kayıt davranışını tekil çalışma grubu sayfalarında değiştirebilirsiniz.",
                "NO_ARCHIVE": "Lisansınız video görüşme kayıt özelliğine sahip değil.",
                "SAVE": "KAYDET"
            },
            "ALWAYS_FULL_HD": {
                "TITLE": "Mobil Cihazlar için Yayın/anlık Görüntü Kalitesi (Toplantılar ve Görüşmeler Dahil)",
                "FULL_HD_MESSAGE": "Desteklenen mobil cihazlarda yayın/anlık görüntü kalitesini FullHD yapın",
                "INDIVIDUAL_MESSAGE": "Yayın/anlık görüntü kalitesi davranışını çalışma grubu ve kullanıcı (görüşmeler için) sayfalarında bireysel olarak değiştirebilirsiniz",
                "CANCEL": "İptal",
                "PROCEED": "Devam Et",
                "CHANGE": "Tekil Olarak Değiştir",
                "SAVE": "KAYDET"
            },
            "FULL_HD_MODAL": {
                "FULL_HD": "Yayın/anlık Görüntü Kalitesini FullHD Yap",
                "CHANGE_INDIVIDUALLY": "Yayın/anlık Görüntü Kalitesi Davranışını Tekil Olarak Değiştir",
                "FULL_HD_MESSAGE": "Yayın/anlık görüntü kalitesi desteklenen mobil cihazlarda FullHD olacaktır.",
                "INDIVIDUAL_MESSAGE": "Yayın/anlık görüntü kalitesi davranışını çalışma grubu ve kullanıcı (görüşmeler için) sayfalarında tekil olarak değiştirebilirsiniz.",
                "WARNING": "Yayın/anlık görüntü kalitesi değişiklikleri sonraki oturumlara uygulanacaktır.",
                "CANCEL": "İptal",
                "PROCEED": "Devam Et",
                "CHANGE": "Tekil Olarak Değiştir"
            },
            "EMAIL_RECIPIENTS": {
                "TITLE": "Haftalık Kullanım Raporu Alıcı Listesi",
                "MESSAGE": "{{ appName }}'den haftalık kullanım raporu almak için daha fazla e-posta adresi ekleyebilirsiniz.",
                "PLACEHOLDER": "Ekle",
                "SECONDARY_PLACEHOLDER": "E-posta adresini girin",
                "ADMIN_MAIL_FIRST": "Lütfen önce kullanıcılar menüsünden yönetici e-posta adresini ekleyin",
                "INVALID_EMAIL": "Geçersiz e-posta formatı.",
                "SAVE": "KAYDET",
                "CANNOT_CHANGE": "Alıcı listesi güncellenemedi.",
                "WARNING": "Lütfen her e-posta adresinden sonra Enter tuşuna basın."
            },
            "TWO_FACTOR_AUTH": {
                "TITLE": "İki Faktörlü Kimlik Doğrulama",
                "ADMIN_2FA": "Admin Panel İki Faktörlü Kimlik Doğrulama",
                "EXPERT_2FA": "Uzman İki Faktörlü Kimlik Doğrulama",
                "CAUTION": "Uzmanlar için etkinleştirmeden önce admin iki faktörlü doğrulamayı etkinleştirmelisiniz.",
                "ENABLE": "Etkinleştir",
                "DISABLE": "Devre Dışı Bırak",
                "TWO_FACTOR_UNAVAILABLE": "Lisansınız İki Faktörlü Kimlik Doğrulama özelliğini içermiyor.",
                "TWO_FACTOR_ENABLED": "İki faktörlü kimlik doğrulama etkinleştirildi",
                "TWO_FACTOR_DISABLED": "İki faktörlü kimlik doğrulama devre dışı bırakıldı"
            },
            "TIMEZONE": {
                "TITLE": "Zaman Dilimini Değiştir",
                "SAVE": "KAYDET",
                "CANNOT_CHANGE": "Zaman dilimi güncellenemedi."
            },
            "DEFAULT_WORK_GROUPS": {
                "TITLE": "Varsayılan Çalışma Grupları",
                "MESSAGE": "Yeni kullanıcılara varsayılan olarak atanacak çalışma gruplarını seçin.",
                "SELECT": "Çalışma grubu seçin",
                "NO_WORK_GROUP": "Bu hesapta henüz çalışma grubu yok.",
                "SAVE": "KAYDET",
                "SAVED": "Varsayılan çalışma grupları güncellendi.",
                "CANNOT_CHANGE": "Varsayılan çalışma grupları güncellenemedi.",
                "STALE_SELECTION": "Seçilen çalışma gruplarından biri artık yok. Sayfayı yenileyin ve tekrar deneyin."
            },
            "VOICE_COMMANDS": {
                "TITLE": "Sesli Komutlar",
                "NEW_COMMAND": "Yeni Komut",
                "LOADING": "Yükleniyor",
                "NO_COMMAND": "Komut listesi boş",
                "COMMAND": "Komut",
                "TRANSLATION": "Çeviri",
                "LANGUAGE": "Dil",
                "UNAVAILABLE": "Lisansınız Sesli Komutlar özelliğini içermiyor.",
                "ADD_MODAL": {
                    "TITLE": "Yeni Komut Ekle",
                    "CLOSE": "Kapat",
                    "ADD": "Ekle"
                }
            },
            "AZURE_AD": {
                "CANCEL": "İptal",
                "ADD": "Ekle",
                "REMOVE": "Kaldır",
                "COPY": "Kopyala",
                "AZURE_AD_INTEGRATION": "Azure AD Entegrasyonu",
                "SINGLE_SIGN_ON": "Tek Oturum Açma",
                "CONFIGURE_SAML": "SAML tabanlı tek oturum açmayı buradan yapılandırabilirsiniz.",
                "ADD_SAML_CONFIGURATION": "SAML Yapılandırması Ekle",
                "REMOVE_SAML_CONFIGURATION": "SAML Yapılandırmasını Kaldır",
                "INFORMATION": "Azure Active Directory tarafından gereken bilgiler",
                "INFORMATION_VSIGHT": "VSight tarafından gereken bilgiler",
                "IDENTIFIER": "Identifier (Entity ID)",
                "REPLY_URL": "Reply URL",
                "REPLY_URL2": "Reply URL2",
                "REPLY_URL3": "Reply URL3",
                "USER_PROVISIONING": "Kullanıcı Sağlama",
                "SCIM_USER_PROVISIONING": "SCIM tabanlı kullanıcı sağlamayı buradan yapılandırabilirsiniz.",
                "ADD_SCIM_CONFIGURATION": "SCIM Yapılandırması Ekle",
                "REMOVE_SCIM_CONFIGURATION": "SCIM Yapılandırmasını Kaldır",
                "INFO": "Azure Active Directory tarafından gereken bilgiler",
                "ENDPOINT": "SCIM Endpoint (Tenant URL)",
                "ADD_SAML": "SAML Yapılandırması Ekle",
                "SSO": "Identity Provider SSO URL",
                "SSO_URL_REQUIRED": "SSO URL gerekli.",
                "CERTIFICATE": "Public x509 Certificate",
                "CERTIFICATE_REQUIED": "Sertifika gerekli.",
                "GENERATE_TOKEN_FOR_SCIM": "SCIM için Token Oluştur",
                "REMOVE_SAML_CONFIGURATION_QUESTION": "SAML yapılandırmasını kaldırmak istediğinizden emin misiniz?",
                "REMOVE_SCIM_CONFIGURATION_QUESTION": "SCIM yapılandırmasını kaldırmak istediğinizden emin misiniz?"
            },
            "OAUTH_OIDC": {
                "OAUTH_OIDC_TITLE": "OAuth OIDC Entegrasyonu",
                "OAUTH_OIDC": "OAuth OpenID Connect",
                "CONFIGURE_OAUTH_OIDC": "OAuth OpenID Connect'i buradan yapılandırabilirsiniz.",
                "ADD_OAUTH_OIDC_CONFIGURATION": "OIDC Yapılandırması Ekle",
                "REMOVE_OAUTH_OIDC_CONFIGURATION": "OIDC Yapılandırmasını Kaldır",
                "INFORMATION": "Ayrıntılar",
                "INITIATE_LOGIN_URL": "Initiate Login Url",
                "REDIRECT_URL": "Redirect Url",
                "COPY": "Kopyala",
                "ADD_OIDC": "OIDC Yapılandırması Ekle",
                "INFORMATION_VSIGHT": "VSight tarafından gereken bilgiler",
                "DISCOVERY_ENDPOINT": "Discovery Endpoint (OpenID Connect metadata document)",
                "DISCOVERY_ENDPOINT_REQUIRED": "Discovery endpoint gerekli.",
                "CLIENT_ID": "Client ID",
                "CLIENT_ID_REQUIRED": "Client ID gerekli.",
                "CLIENT_SECRET": "Client Secret",
                "CLIENT_SECRET_REQUIRED": "Client secret gerekli.",
                "RESPONSE_TYPE": "Response Type",
                "RESPONSE_TYPE_CODE": "code",
                "LOGOUT_URL": "Logout Url",
                "REMOVE_OIDC_CONFIGURATION": "OIDC Yapılandırmasını Kaldır",
                "REMOVE_OIDC_CONFIGURATION_QUESTION": "OIDC yapılandırmasını kaldırmak istediğinizden emin misiniz?",
                "CANCEL": "İptal",
                "ADD": "Ekle",
                "REMOVE": "Kaldır"
            },
            "ENABLE_SYSTEM_EMAIL": {
                "CONFIGURE_CUSTOM_SERVICE_EMAIL": "Özel Servis E-postasını Yapılandır",
                "SENDER_NAME": "Gönderen Adı",
                "SENDER_NAME_IS_REQUIRED": "Gönderen adı gerekli.",
                "SENDER_HOST": "Host adresi",
                "SENDER_HOST_IS_REQUIRED": "Host adresi gerekli.",
                "SENDER_PORT": "Port",
                "SENDER_EMAIL": "E-posta",
                "SENDER_EMAIL_IS_REQUIRED": "E-posta gerekli.",
                "USER": "Kullanıcı",
                "USER_IS_REQUIRED": "Kullanıcı gerekli.",
                "EMAIL_FORMAT_IS_INVALID": "Geçersiz e-posta formatı.",
                "PASSWORD": "Şifre",
                "PASSWORD_IS_REQUIRED": "Şifre gerekli.",
                "CANCEL": "İptal",
                "VERIFY": "Doğrula",
                "VERIFY_CUSTOM_SERVICE_EMAIL": "Özel Servis E-postasını Doğrula",
                "SEND_VERIFICATION_CODE": "Size bir doğrulama kodu içeren bir e-posta gönderdik."
            },
            "DISABLE_SYSTEM_EMAIL": {
                "DISABLE_CUSTOM_SERVICE_EMAIL": "Özel Servis E-postasını Devre Dışı Bırak",
                "SYSTEM_EMAILS_SEND": "Sistem e-postaları varsayılan VSight servis e-posta adresinden gönderilecektir.",
                "CANCEL": "İptal",
                "DISABLE": "Devre Dışı Bırak"
            },
            "ALWAYS_ARCHIVE": {
                "AUTO_RECORD": "Tüm Çalışma Gruplarını Otomatik Olarak Kaydet",
                "CHANGE_INDIVIDUALLY": "Çalışma Grubu Kayıt Davranışını Tekil Olarak Değiştir",
                "AUTO_MESSAGE": "Tüm çalışma grubu oturumları otomatik olarak kaydedilecektir.",
                "INDIVIDUAL_MESSAGE": "Çalışma grubu kayıt davranışını tekil çalışma grubu sayfalarında değiştirebilirsiniz.",
                "WARNING": "Otomatik video çağrı kaydındaki değişiklikler sonraki oturumlara uygulanacaktır.",
                "CAUTION": "DİKKAT: Bu bir Peer-to-Peer çalışma grubudur. Bu çalışma grupları için kayıt mevcut değildir.",
                "CANCEL": "İptal",
                "PROCEED": "Devam Et",
                "CHANGE": "Tekil Olarak Değiştir"
            },
            "WHAT_IS_P2P": {
                "TITLE": "Peer-to-Peer Nedir",
                "BETWEEN_CLIENTS": "İstemciler ses-görüntü akışlarını doğrudan birbirlerine gönderir.",
                "REDUCED_LATENCY": "Peer-to-Peer seçeneği, azaltılmış gecikme süresi avantajını sunar.",
                "ARCHIVE_UNAVAILABLE": "Peer-to-Peer oturumları kaydedilemez, çünkü bağlantı oturumda yer alan eşler arasında doğrudan kurulur.",
                "CLOSE": "Kapat"
            },
            "ADD_EMAIL": {
                "TITLE": "E-posta gerekli",
                "ADMIN": "Tüm yönetici ve yardımcı yönetici e-posta adreslerini kullanıcı sayfalarından eklemeniz gerekiyor.",
                "ALL": "Tüm e-posta adreslerini kullanıcı sayfalarından eklemeniz gerekiyor.",
                "GO_TO_PROFILE": "Profile git",
                "USER_MAILS": "Lütfen aşağıdaki kullanıcıların e-posta adreslerini ekleyin:",
                "CLOSE": "Kapat"
            },
            "TWO_FACTOR_MODAL": {
                "ENABLE_ADMIN": "Admin İki Faktörlü Kimlik Doğrulamayı Etkinleştir",
                "DISABLE_ADMIN": "Admin İki Faktörlü Kimlik Doğrulamayı Devre Dışı Bırak",
                "ENABLE_ALL": "Tüm Kullanıcılar için İki Faktörlü Kimlik Doğrulamayı Etkinleştir",
                "DISABLE_ALL": "Admin Hariç Tüm Kullanıcılar için İki Faktörlü Kimlik Doğrulamayı Devre Dışı Bırak",
                "VERIFICATION_SENDED": "Size bir doğrulama kodu içeren bir e-posta göndereceğiz.",
                "VERIFICATION_CODE": "Doğrulama Kodu",
                "CANCEL": "İptal",
                "SEND_CODE": "Kodu Gönder",
                "PROCEED": "Devam Et"
            },
            "WHITELABEL_SETTINGS": {
                "TITLE": "Whitelabel Ayarları",
                "SYSTEM_EMAIL_TITLE": "Sistem e-posta ayarlarını özelleştir",
                "SYSTEM_EMAIL_MESSAGE": "Hizmet e-posta adresinizi buradan yapılandırabilirsiniz.",
                "ENABLE": "Etkinleştir",
                "DISABLE": "Devre Dışı Bırak"
            },
            "TICKET_TYPES": {
                "TITLE": "Ticket Tipleri",
                "NEW_TYPE": "Yeni Ticket Tipi Ekle",
                "NO_TYPE": "Tanımlanmış ticket tipi yok",
                "LOADING": "Ticket tipleri yükleniyor...",
                "ID": "ID",
                "NAME": "İsim",
                "NAME_PLACEHOLDER": "Ticket tipi adını girin",
                "REMOVE": "Kaldır",
                "SAVE": "Değişiklikleri Kaydet",
                "SAVING": "Kaydediliyor...",
                "ERROR_LOADING": "Ticket tipleri yüklenemedi",
                "ERROR_SAVING": "Ticket tipleri kaydedilemedi",
                "SUCCESS": "Ticket tipleri başarıyla kaydedildi",
                "VALIDATION_ERROR": "Lütfen tüm ticket tipleri için bir isim girin",
                "DUPLICATE_ID_ERROR": "Aynı isimdeki ticket tipleri aynı ID oluşturur. Lütfen benzersiz isimler kullanın.",
                "REMOVE_CONFIRM": "Bu ticket tipini kaldırmak istediğinizden emin misiniz?",
                "REMOVE_TITLE": "Ticket Tipini Kaldır"
            },
            "PASSWORD_POLICY": {
                "TITLE": "Şifre Politikası",
                "SPECIFY_RULE": "Kullanıcılarınızın şifre kurallarını belirtin",
                "MIN_LENGTH": "Minimum şifre uzunluğu",
                "FOLLOWING_CRITERIAS": "Aşağıdaki kriterleri karşılamalıdır",
                "SAVE": "KAYDET",
                "SUCCESS": "Şifre ayarlarınız değiştirildi",
                "ERROR": "Bir hata oluştu.",
                "UPPERCASE": "Büyük Harf",
                "LOWERCASE": "Küçük Harf",
                "NUMBER": "Sayı",
                "SPECIAL": "Özel Karakter"
            },
            "CONTACT_INFO": {
                "TITLE": "İletişim Bilgileri",
                "NEW": "Yeni İletişim",
                "CONTACT": "İletişim",
                "DEPARTMENT": "Departman",
                "NAME": "İsim",
                "EMAIL": "E-posta",
                "PHONE": "Telefon Numarası",
                "DELETE": "Sil",
                "EDIT": "Düzenle",
                "CANCEL": "İptal",
                "REVERT": "Geri Al",
                "DEP_REQ": "Departman Gerekli",
                "NAME_REQ": "İsim Gerekli",
                "EMAIL_REQ": "E-posta Gerekli",
                "INVALID_EMAIL": "Geçersiz E-posta",
                "SAVE": "KAYDET",
                "SUCCESS": "İletişim bilgileri başarıyla güncellendi.",
                "FAILED": "İletişim bilgileri güncellemesi başarısız oldu."
            },
            "SYS_REQ": {
                "TITLE": "Donanım ve Yazılım Gereksinimleri",
                "ANDROID_TITLE": "Android Cihazlar için Gereksinimler",
                "IOS_TITLE": "iOS Cihazlar için Gereksinimler",
                "NETWORK_TITLE": "Ağ Gereksinimleri",
                "BROWSERS_TITLE": "Desteklenen Tarayıcılar",
                "ANDROID_VERSION": "Android 5.0 veya daha yeni",
                "ANDROID_RAM": "1.5 GB RAM veya daha yüksek",
                "ANDROID_CORE_SPEED": "Maksimum Çekirdek hızı 1.5 GHz veya daha yüksek",
                "ANDROID_ARCORE": "AR+ kullanmak için cihazınızın ARCore'u desteklemesi gerekir. ARCore'u destekleyen cihazlar bu sayfada bulunabilir: ",
                "ANDROID_ARCORE_DEVICE": "ARCore destekleyen cihazlar",
                "IOS_VERSION": "iOS 13 veya daha yeni",
                "IOS_IPHONE": "iPhone 8 veya daha yeni",
                "IOS_IPAD": "iPad Pro 2017 veya daha yeni",
                "IOS_ARKIT": "AR+ kullanmak için cihazınızın ARkit'i desteklemesi gerekir. ARkit'i destekleyen cihazlar bu sayfada bulunabilir: ",
                "IOS_ARKIT_DEVICE": "ARkit destekleyen cihazlar",
                "NETWORK_BODY": "Kararlı bir video bağlantısını sürdürmek için 350 Kbps indirme ve yükleme hızı gereklidir, ancak daha iyi sonuçlar elde etmek için düşük gecikme ile 1 Mbps indirme ve yükleme hızı önerilir.",
                "CHROME": "Google Chrome",
                "FIREFOX": "Mozilla Firefox",
                "SAFARI": "Safari (12 veya daha yeni)",
                "EDGE": "Microsoft Edge (79 veya daha yeni)"
            }
        },
        "LICENCE-EXPIRED": "Lisansınızın süresi doldu",
        "SESSIONS": {
            "SESSION_DETAILS": {
                "TITLE": "Oturum Detayları",
                "BACK": "Geri",
                "WIPE_SESSION_DATA": "Oturum Verilerini Sil",
                "SESSION_DATA_WIPED": "Oturum verileri zaten silindi",
                "PARTICIPANTS": "Katılımcılar",
                "CREATED_AT": "Oluşturulma Tarihi: ",
                "DURATION": "Süre: ",
                "GUEST": "(Misafir)",
                "ATTACHED_TICKET": "İlişkilendirilmiş Ticket",
                "ATTACH_TO_TICKET": "Ticketla İlişkilendir",
                "CHANGE_TICKET": "Ticket Degistir",
                "ATTACH_SESSION_TO_TICKET": "Oturumu Ticketla İlişkilendir",
                "CLOSE": "Kapat",
                "ATTACH": "Ekle",
                "APPLY_FILTERS": "Filtreleri Uygula",
                "SESSIONS": "Oturumlar",
                "SESSION_COUNT": "Oturum Sayısı",
                "TOTAL_DURATION": "Toplam Süre",
                "EXPORT": "Dışa Aktar",
                "GET_SESSION_EXPORT": "Oturum Dışa Aktarımını Al",
                "DATE": "Tarih",
                "USER_ROLES": {
                    "UNKNOWN": "Unknown",
                    "ADMIN": "Admin",
                    "CO_ADMIN": "Co-Admin",
                    "EXPERT": "Expert",
                    "USER": "User",
                    "SUBSCRIBER": "Subscriber"
                },
                "SESSION_EXPORT": {
                    "TITLE": "Oturumu Dışa Aktar",
                    "MESSAGE": "Oturum dışa aktarma, oturumda paylaşılan tüm sohbet mesajlarını, anlık görüntüleri, görüşme kayıtlarını ve dosyaları içerir.",
                    "SEND": "Gönder",
                    "EXPORT_SUCCEEDED": "Oturum dışa aktarma, oturum sona erdikten sonra gönderilecektir.",
                    "EXPORT_FAILED": "Bir hata oluştu.",
                    "WARNING": "Lütfen her e-posta adresinden sonra Enter tuşuna basın."
                },
                "WIPE_SESSION_DATA_MODAL": {
                    "TITLE": "Oturum Verilerini Sil?",
                    "MESSAGE": "Oturum verilerini silmek istediğinizden emin misiniz? Anlık görüntüler, görüşme kayıtları ve oturumda paylaşılan dosyalar silinecektir.",
                    "WARNING": "Bu işlem geri alınamaz.",
                    "CLOSE": "Kapat",
                    "WIPE": "Sil",
                    "WIPE_SUCCEEDED": "Oturum verileri silindi.",
                    "WIPE_FAILED": "Bir hata oluştu."
                },
                "SESSION_CHAT": {
                    "COLLABORATE": "İşbirliği Yap",
                    "CLOSE_COLLABORATION": "İşbirliğini Kapat",
                    "DOWNLOAD": "İndir",
                    "DELETE": "Sil",
                    "DETAILS": "Detaylar",
                    "FILE_DELETED": "Dosya silindi",
                    "JOIN_ROOM": "{{ owner_info }} iş grubu katıldı.",
                    "LEAVE_ROOM": "{{ owner_info }} iş grubundan ayrıldı.",
                    "REACTION": "{{ owner_info }} bir tepki gönderdi.",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} anlık görüntü talep etti.",
                    "SHARE_SCREENSHOT": "{{ owner_info }} bir anlık görüntü paylaştı.",
                    "SHARE_IMAGE": "{{ owner_info }} bir resim paylaştı.",
                    "SHARE_PDF": "{{ owner_info }} bir pdf paylaştı.",
                    "SHARE_OTHER": "{{ owner_info }} bir dosya paylaştı.",
                    "SHARE_OBJECT": "{{ owner_info }} bir 3D nesne paylaştı.",
                    "COLLABORATED": "{{ owner_info }} işbirliği yaptı."
                },
                "FILES": "Dosyalar",
                "CHAT": "Sohbet"
            },
            "SESSION_LIST": {
                "ALL_SESSIONS": "Tüm Oturumlar",
                "LAST_SESSIONS": "Son Oturumlar",
                "ROOM_SESSIONS": "{{room}}'deki Son 3 Oturum",
                "LOADING": "Yükleniyor",
                "NO_SESSION_MESSAGE": "Oturum listesi boş",
                "DATE": "Tarih",
                "ROOM_NAME": "İş Grubu Adı",
                "PARTICIPANTS": "Katılımcılar",
                "STATUS": "Durum",
                "DURATION": "Süre",
                "GUEST": "(Misafir)",
                "ON_GOING": "Devam Ediyor",
                "ENDED": "Sona Erdi",
                "START_END": "Başlangıç Bitiş",
                "ALL_ROOMS": "Tüm İş Grupları",
                "ALL_USERS": "Tüm Kullanıcılar",
                "ALL_LABELS": "Tüm Etiketler",
                "CSV": "CSV",
                "EXPORT_HEADER": "Oluşturulma Tarihi,Oda,Süre (dakika),Katılımcılar",
                "UNKNOWN": "Bilinmiyor",
                "GUEST_LABEL": " (Misafir)",
                "MORE": "daha fazla"
            },
            "SESSION_FILES": {
                "DOWNLOAD_STARTED_SOON": "İndirme yakında başlayacak.",
                "DOWNLOAD_FAILED": "İndirme başarısız oldu.",
                "NO_FILE_IS_ADDED": "Bu oturumda hiçbir dosya eklenmedi veya işbirliği yapılmadı.",
                "FILE_NAME": "Dosya Adı:",
                "FILE_CONTENTS": "Dosya İçeriği:",
                "FILE_SIZE": "Dosya Boyutu:",
                "ESTIMATED_FILE_SIZE": "Tahmini Boyut:",
                "APPROX_EXPORT_PDF_SIZE": "Yaklaşık 60 KB"
            }
        },
        "USERS": {
            "USER_DETAILS": {
                "BACK": "Geri",
                "TITLE_NEW": "Yeni Kullanıcı",
                "TITLE_DETAILS": "Kullanıcı Detayları",
                "TITLE_EDIT": "Kullanıcıyı Düzenle",
                "USER_DISABLED": "KULLANICI DEVRE DIŞI",
                "EDIT": "Düzenle",
                "RESET": "Sıfırla",
                "REVERT": "Geri Al",
                "CANCEL": "İptal",
                "USER_ROLE": "Rol",
                "ADMIN": "Admin",
                "COADMIN": "Co-Admin",
                "USER": "User",
                "SUBSCRIBER": "Subscriber",
                "EXPERT": "Expert",
                "NAME": "İsim",
                "ROLE": "Rol",
                "PERMISSIONS": "İzinler",
                "CLOSE": "Kapat",
                "REACHED_MAX_NUMBER_EXPERT_LIMIT": "Maksimum uzman sayısına ulaşıldı.",
                "SINGLE_SIGN_ON_CODE": "Tek Oturum Açma Kodu",
                "GENERATING": "Oluşturuluyor",
                "GENERATE_CODE": "Kodu Oluştur",
                "CLICK_CODE_FOR_COPY": "Kopyalamak için koda tıklayın",
                "ARCHIVE_UNAVAILABLE": "Lisansınızda video çağrı kaydetme özelliği yok.",
                "ALLOW_ARCHIVING": "Video çağrılarını başlatma/durdurma izni",
                "PERSONAL_ROOM_SETTINGS": "Kişisel Çalışma Grubu Ayarları (Görüşme Sırasında)",
                "CALL_ARCHIVE_PERM_NEEDED": "Kayda başlamak için tüm kullanıcıların izni gereklidir.",
                "CALLING_UNAVAILABLE": "Lisansınızda arama yapma özelliği yok.",
                "ALLOW_CALLING": "Arama yapma izni",
                "ALLOW_SEEING_ALL_USERS": "Tüm kullanıcıları görme izni",
                "JOIN_LINK_UNAVAILABLE": "Lisansınızda misafir erişim özelliği yok.",
                "ALLOW_JOIN_LINK": "Misafir Erişimi oluşturma izni",
                "PERMISSION_TO_SEE_USERS_IN_SAME_ROOM": "Aynı çalışma grubundaki kullanıcıları görme izni",
                "PERMISSION_TO_SEE_USERS_ALL": "Tüm kullanıcıları görme izni",
                "NAME_REQUIRED": "İsim gerekli",
                "NAME_START_WITH": "Alfanümerik karakterle başlamalı.",
                "NAME_CONTAINS": "Alfanümerik ve özel karakterler -._ (boşluk) içerebilir",
                "NAME_LENGTH": "İsim uzunluğu 1-60 karakter arasında olmalıdır.",
                "USERNAME": "Kullanıcı Adı",
                "USERNAME_REQUIRED": "Kullanıcı adı gerekli",
                "USERNAME_ALREADY_TAKEN": "Zaten alınmış",
                "USERNAME_CONTAINS": "Sadece alfanümerik karakterler, alt çizgi ( _ ) ve tire ( - ) içeren bir kullanıcı adı seçin",
                "USERNAME_LENGTH": "Kullanıcı adı uzunluğu 1-30 karakter arasında olmalıdır.",
                "EMAIL": "E-posta",
                "EMAIL_REQUIRED": "E-posta gerekli",
                "EMAIL_INVALID": "Geçersiz e-posta",
                "PASSWORD": "Şifre",
                "PASSWORD_REQUIRED": "Şifre gerekli",
                "PASSWORD_MINLENGTH": "Şifre uzunluğu 6-30 karakter arasında olmalıdır.",
                "CONFIRM_PASSWORD": "Şifreyi Onayla",
                "CONFIRM_PASSWORD_NOTMATCH": "Şifreler eşleşmiyor.",
                "DEFAULT_ROOM": "Varsayılan Çalışma Grubu",
                "ROOMS": "Çalışma Grupları",
                "WORK_GROUP_SETTINGS": "Çalışma Grubu Ayarları",
                "SELECT_ROOMS": "Çalışma Gruplarını Seç",
                "SAVE": "Kaydet",
                "CALL_INFO_MODAL": {
                    "TITLE": "Arama İzni?",
                    "MESSAGE": "Arama iznine sahip kullanıcılar, daha önce oluşturulmuş bir çalışma grubuna ihtiyaç duymadan kullanıcı listesine erişebilir ve arama yapabilir.",
                    "CLOSE": "Kapat"
                },
                "QR_CODE_TITLE": "QR Kodu",
                "QR_CODE_LOADING": "QR Kodu Yükleniyor",
                "QR_ENABLE_FIRST": "Kullanıcı Devre Dışı",
                "NO_QR_CODE": "QR Kodu Yok",
                "GENERATE_QR": "QR Kodu Oluştur",
                "QR_MESSAGE": "Bu QR kodu ile akıllı gözlükleri ve mobil telefonları doğrulayabilirsiniz.",
                "REGENERATE": "Yeniden Oluştur",
                "REMOVE": "Sil",
                "DOWNLOAD": "İndir",
                "CHANGE_PASSWORD_TITLE": "Şifre Değiştir",
                "CHANGE_PASSWORD": "ŞİFRE DEĞİŞTİR",
                "CREATE_NEW_PASSWORD": "Şifre Gereksinimleri",
                "UPPERCASE": "Büyük Harf",
                "LOWERCASE": "Küçük Harf",
                "NUMBER": "Rakam",
                "SPECIAL": "Özel Karakter",
                "NOT_WHITESPACE": "Şifreniz boşluk karakterleri içermemelidir",
                "AT_LEAST_PASSWORD_LENGTH": "En az {{ passwordlength }} karakter olmalıdır",
                "DO_NOT_CREATE_SIMPLE": "'123456' gibi zayıf şifreler oluşturmayın",
                "CHANGE_PASSWORD_MODAL": {
                    "TITLE": "Şifreyi Değiştir?",
                    "MESSAGE": "Kullanıcı şifresi değiştirilecektir.",
                    "CAUTION": "DİKKAT: Lütfen mevcut kullanıcı QR kodunun silineceğini unutmayın.",
                    "CANCEL": "İptal",
                    "CHANGE": "Değiştir"
                },
                "PASSWORD_CHANGED": "Şifre değiştirildi.",
                "CANNOT_CHANGE": "Şifre değiştirilemedi.",
                "QR_REMOVE_TITLE": "QR Kodunu Sil?",
                "QR_REMOVE_MESSAGE": "QR kodu silinecektir.",
                "QR_REMOVE_NO": "İptal",
                "QR_REMOVE_YES": "Sil",
                "QR_REGENERATE_TITLE": "Yeniden Oluştur?",
                "QR_REGENERATE_MESSAGE": "Önceki QR kodu devre dışı bırakılacaktır.",
                "QR_REGENERATE_NO": "İptal",
                "QR_REGENERATE_YES": "Yeniden Oluştur",
                "QR_REMOVED": "QR kodu silindi.",
                "CANNOT_REMOVE": "QR kodu silinemedi.",
                "QR_GENERATED": "QR kodu oluşturuldu.",
                "CANNOT_GENERATE": "QR kodu oluşturulamadı.",
                "USER_UPDATED": "Kullanıcı başarıyla güncellendi.",
                "CANNOT_UPDATE": "Kullanıcı güncellenemedi.",
                "USER_CREATED": "Kullanıcı oluşturuldu.",
                "CANNOT_CREATE": "Kullanıcı oluşturulamadı.",
                "UPDATE_USER_MODAL": {
                    "TITLE": "Değişiklikleri Uygula?",
                    "USENAME_MESSAGE": "Kullanıcı adı değiştirilecektir.",
                    "USENAME_CAUTION": "DİKKAT: Lütfen mevcut kullanıcı QR kodunun silineceğini unutmayın.",
                    "EMAIL_MESSAGE": "Admin e-posta adresi silinecektir.",
                    "EMAIL_CAUTION": "DİKKAT: Artık haftalık kullanım raporları almayacaksınız. Diğer alıcılar da kaldırılacaktır.",
                    "CANCEL": "İptal",
                    "CHANGE": "Değiştir"
                },
                "WITHOUT_ROOM_MODAL": {
                    "TITLE": "Hiçbir çalışma grubu olmadan kullanıcı oluştur?",
                    "MESSAGE": "Kullanıcı, hiçbir çalışma grubuna sahip olmadan oluşturulacaktır.",
                    "CANCEL": "İptal",
                    "CREATE": "Oluştur"
                },
                "DISABLE_USER": "KULLANICIYI DEVRE DIŞI BIRAK",
                "ENABLE_USER": "KULLANICIYI ETKİNLEŞTİR",
                "TOGGLE_USER_MODAL": {
                    "TITLE_ENABLE": "Kullanıcıyı Etkinleştir?",
                    "TITLE_DISABLE": "Kullanıcıyı Devre Dışı Bırak?",
                    "MESSAGE_ENABLE": "Kullanıcı <strong>{{name}}</strong> etkinleştirilsin mi?",
                    "MESSAGE_DISABLE": "Kullanıcı <strong>{{name}}</strong> devre dışı bırakılsın mı?",
                    "CANCEL": "İptal",
                    "ENABLE": "Etkinleştir",
                    "DISABLE": "Devre Dışı Bırak",
                    "ENABLED": "Kullanıcı etkinleştirildi.",
                    "DISABLED": "Kullanıcı devre dışı bırakıldı.",
                    "ERROR": "Kullanıcı durumu değiştirilemedi."
                },
                "DELETE_USER": "KULLANICIYI SİL",
                "DELETE_USER_MODAL": {
                    "TITLE": "Kullanıcıyı Sil?",
                    "MESSAGE": "Kullanıcı <strong>{{name}}</strong> silinsin mi?",
                    "CAUTION": "DİKKAT: Bu işlem geri alınamaz!",
                    "CANCEL": "İptal",
                    "DELETE": "Sil",
                    "DELETED": "Kullanıcı silindi.",
                    "ERROR": "Kullanıcı silinemedi."
                },
                "LABEL": "Etiket",
                "CREATE_NEW_LABELS": "Yeni oluştur"
            },
            "ALL_ROOMS": "Tüm Odalar",
            "ALL_ROLES": "Tüm Roller",
            "NAME_USERNAME": "Ad veya Kullanıcı Adı"
        },
        "ANALYTICS": {
            "TITLE": "Organizasyon Analitiği",
            "DASHBOARD": "Dashboard",
            "USAGE": "Kullanım",
            "TOTAL_COMPLETIONS": "Toplam Gönderi",
            "ACTIVE_DOMAINS": "Aktif Alanlar",
            "SHARED_WORKFLOWS": "Paylaşılan İş Akışları",
            "COMPLETIONS_BY_DOMAIN": "Alana Göre",
            "COMPLETIONS_BY_WORKFLOW": "İş Akışına Göre",
            "NOT_AVAILABLE": "Analitik yalnızca ana hesaplar için kullanılabilir.",
            "START_DATE": "Başlangıç Tarihi",
            "END_DATE": "Bitiş Tarihi",
            "DOMAIN": "Alana Göre",
            "WORKFLOW": "İş Akışına Göre",
            "COMPLETIONS": "Tamamlanma",
            "TOTAL_WORKFLOWS": "Toplam İş Akışları",
            "TOTAL_SHARED_WORKFLOWS": "Toplam Paylaşılan İş Akışları",
            "TOTAL_USERS": "Toplam Kullanıcılar",
            "TOTAL_SUBMISSIONS": "Toplam Gönderimler",
            "CHILD_ACCOUNTS_BREAKDOWN": "Alt Hesap Dökümü",
            "ACCOUNT": "Hesap",
            "WORKFLOWS": "İş Akışları",
            "SHARED": "Paylaşılan",
            "USERS": "Kullanıcılar",
            "SUBMISSIONS": "Gönderimler"
        },
        "STORAGE": {
            "TITLE": "Video Görüşmesi Kayıt Depolama",
            "REMOTE_ASSISTANCE_STORAGE": "Uzaktan Destek Depolama",
            "CONNECT_AZURE": "Azure'a Bağlan",
            "DISCONNECT_AZURE": "Azure'dan Bağlantıyı Kes",
            "SHARED_DEDICATED_SIZE": "Toplam {{dedicated}} GB Bulut Depolama alanınız var",
            "SHARED_DEDICATED_DELETE": "Depolama alanınız dolduğunda, eski video görüşmesi kayıtları silinecektir.",
            "SHARED_EXPIRE_TIME": "Video görüşmesi kayıtlarınız {{expire}} gün boyunca saklanacaktır.",
            "SHARED_EXPIRE_DELETE": "Süresi dolduktan sonra, video görüşmesi kayıtları silinecektir.",
            "SHARED_UNLIMITED": "Tüm video kayıtlarınız için sınırsız, süresiz depolama kapasitesi sağlıyoruz.",
            "PRIVATE_STORAGE_MESSAGE": "Azure Bulut Depolama hesabınızı {{appName}}'ye bağlayabilirsiniz.",
            "PRIVATE_STORAGE_EXPLANATION": "Video görüşmesi kayıtları, depolama alanınıza yüklenecektir.",
            "PRIVATE_NO_AZURE": "AZURE BULUT DEPOLAMA BAĞLI DEĞİL",
            "PRIVATE_AZURE": "AZURE BULUT DEPOLAMA BAĞLI",
            "PRIVATE_AZURE_NAME": "Hesap Adı: {{account_name}}",
            "AZURE_INFO_LOADING": "Yükleniyor",
            "CHECK_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Azure Bulut Depolama'ya Bağlan",
                "DISCONNECT_AZURE_CLOUD_STORAGE": "Azure Bulut Depolama'dan Bağlantıyı Kes",
                "CAUTION": "DİKKAT: Video görüşmesi kaydı kaydetme işlemi devam ediyor. Depolama alanını değiştirmek, kayıt kaybına neden olabilir.",
                "CANCEL": "İptal",
                "CONNECT_ANYWAY": "Yine de Bağlan",
                "DISCONNECT_ANYWAY": "Yine de Bağlantıyı Kes"
            },
            "CONNECT_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Azure Bulut Depolama'ya Bağlan",
                "ACCOUNT_NAME": "Hesap Adı",
                "ACCOUNT_NAME_IS_REQUIRED": "Hesap adı gerekli.",
                "CONTAINER_NAME": "Container Adı",
                "CONTAINER_NAME_IS_REQUIRED": "Container adı gerekli.",
                "ACCOUNT_KEY": "Hesap Anahtarı",
                "ACCOUNT_KEY_IS_REQUIRED": "Hesap anahtarı gerekli.",
                "CANCEL": "İptal",
                "CONNECT": "Bağlan"
            },
            "DISCONNECT_AZURE_MODAL": {
                "TITLE": "Azure Bulut Depolama'dan Bağlantıyı Kes?",
                "MESSAGE": "Azure hesabınız bağlantısı kesilecektir.",
                "CAUTION": "DİKKAT: Bu hesabı bağlantıyı keserseniz, {{appName}} Admin Paneli kullanarak bu Azure hesabında kaydedilen kayıtları indiremezsiniz.",
                "CANCEL": "İptal",
                "DISCONNECT": "Bağlantıyı Kes"
            },
            "ARCHIVE_STORAGE": {
                "ARCHIVE_UNAVAILABLE": "Video Call Record: Your licence doesn't contain this feature.",
                "PRIVATE_STORAGE_UNAVAILABLE": "Your licence does not contain the Azure Integration feature."
            },
            "WEBDAV_MESSAGE": "Video görüşmesi kayıtları webdav hesabınıza yüklenecektir.",
            "MESSAGES": {
                "AZURE_CONNECTED": "Azure bulut depolama bağlandı.",
                "AZURE_DISCONNECTED": "Azure bulut depolama bağlantısı kesildi.",
                "CANNOT_CONNECT": "Azure bulut depolama bağlanılamıyor.",
                "CANNOT_DISCONNECT": "Azure bulut depolama bağlantısı kesilemiyor."
            }
        },
        "ROOM": {
            "SIDEBAR": {
                "CHAT_TITLE": "Chat",
                "PARTICIPANTS_TITLE": "Katılımcılar",
                "FILES_TITLE": "Dosyalar",
                "SETTINGS_TITLE": "Ayarlar",
                "SHOW_TICKET": "Bilet Göster",
                "ATTACH_TO_TICKET": "Ticketla İlişkilendir",
                "ATTACH_SESSION_TO_TICKET": "Oturumu Ticketla İlişkilendir",
                "OPEN_WORKFLOW": "İş Akışlarını Aç",
                "CHAT": {
                    "SEE_TRANSLATION": "Çeviriyi Gör",
                    "SEE_ORIGINAL": "Orijinali Gör",
                    "TRANSLATING": "Çeviriliyor",
                    "FILE_SHARE": {
                        "DRAG_HERE": "Dosyaları Buraya Sürükleyin",
                        "UPLOAD_TITLE": "Dosyaları Yükle",
                        "IMAGE": "Görüntü",
                        "PDF": "PDF",
                        "3D_OBJECT": "3D Nesne",
                        "OTHER": "Diğer",
                        "MULTIPLE_OBJECTS": "Birden fazla nesne bulduk. Lütfen bir nesneyi (varsa dokularla birlikte) tek seferde yükleyin.",
                        "LARGER_THAN": "{{ megabytes }} MB'dan büyük",
                        "FILETYPE_PROHIBITED": "Dosya türü yasaklandı",
                        "START_UPLOAD": "YÜKLE",
                        "CANCEL_UPLOAD": "DURDUR",
                        "CLOSE_UPLOAD": "KAPAT",
                        "CANCEL_MODAL_TITLE": "Yüklemeleri Durdur?",
                        "CANCEL_MODAL_MESSAGE": "Bu, mevcut yüklemeleri durduracaktır.",
                        "CANCEL_MODAL_CLOSE": "İptal",
                        "CANCEL_MODAL_CANCEL": "Durdur"
                    },
                    "DELETE_FILE_MODAL": {
                        "TITLE": "Dosyayı Sil?",
                        "MESSAGE": "Dosya silinecektir.",
                        "CLOSE": "Kapat",
                        "DELETE": "Sil"
                    },
                    "FILE_DETAILS_MODAL": {
                        "TITLE": "Dosya Detayları",
                        "FILENAME": "Dosya Adı",
                        "SIZE": "Boyut",
                        "TYPE": "Tür",
                        "UPLOAD_TIME": "Yükleme Zamanı",
                        "DOWNLOAD": "İndir",
                        "CLOSE": "Kapat",
                        "FILECOUNT": "Toplam Dosya Sayısı"
                    },
                    "COLLABORATE": "İş Birliği Yap",
                    "CLOSE_COLLABORATION": "İş Birliğini Kapat",
                    "DOWNLOAD": "İndir",
                    "DELETE": "Sil",
                    "DETAILS": "Detaylar",
                    "SEND_TO_FILES": "Dosyalara Gönder",
                    "FILE_DELETED": "Dosya silindi",
                    "JOIN_ROOM": "{{ owner_info }} iş grubuna katıldı.",
                    "LEAVE_ROOM": "{{ owner_info }} iş grubundan ayrıldı.",
                    "REACTION": "{{ owner_info }} bir tepki gönderdi.",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} bir ekran görüntüsü aldı.",
                    "SHARE_SCREENSHOT": "{{ owner_info }} bir ekran görüntüsü paylaştı.",
                    "SAVED_COLLABORATION": "İş birliği kaydedildi",
                    "SHARE_IMAGE": "{{ owner_info }} bir resim paylaştı.",
                    "SHARE_PDF": "{{ owner_info }} bir PDF paylaştı.",
                    "SHARE_OTHER": "{{ owner_info }} bir dosya paylaştı.",
                    "SHARE_OBJECT": "{{ owner_info }} bir 3D nesne paylaştı.",
                    "COLLABORATED": "{{ owner_info }} iş birliğine başladı.",
                    "TYPE_HERE": "buraya yaz...",
                    "PLEASE_WAIT_OTHERS": "Lütfen diğer kullanıcıların katılmasını bekleyin.",
                    "DOWNLOAD_STARTED_SOON": "İndirme kısa süre içinde başlayacak",
                    "DOWNLOAD_FAILED": "İndirme başarısız oldu",
                    "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Bu nesnenin indirilmesi henüz desteklenmiyor.",
                    "DOWNLOAD_NOT_SUPPORTED": "Bu indirme henüz desteklenmiyor.",
                    "CLOSE_PREV_COLLABORATION_TITLE": "Mevcut dosya iş birliğini kapat?",
                    "CLOSE_COLLABORATION_TITLE": "Dosya iş birliğini kapat?",
                    "CLOSE_PREV_COLLABORATION_MESSAGE": "Bu, mevcut dosya iş birliğini kapatacak ve yeni bir tane başlatacaktır.",
                    "CLOSE_COLLABORATION_MESSAGE": "Bu, dosya iş birliğini kapatacaktır.",
                    "CLOSE_PREV_COLLABORATION_YES": "Devam",
                    "CLOSE_PREV_COLLABORATION_NO": "İptal",
                    "DISABLE_FOCUS_MODAL": {
                        "TITLE": "Dosya iş birliğini aç?",
                        "MESSAGE_AUTHORIZED": "Sabitlenmiş bir pencere var. Onu sabitlemek ve dosya iş birliğini açmak istiyor musunuz?",
                        "MESSAGE_UNAUTHORIZED": "Dosya iş birliği açılamıyor, çünkü sabitlenmiş bir pencere var.",
                        "CANCEL": "İptal",
                        "CLOSE": "Kapat",
                        "PROCEED": "Devam"
                    },
                    "CLOSE_ARPLUS_BEFORE_COLL": {
                        "TITLE": "AR+'ı kapat?",
                        "MESSAGE": "İş birliğini açmadan önce AR+'ı kapatmalısınız. AR+'ı kapatmak istediğinizden emin misiniz?",
                        "NO": "Hayır",
                        "YES": "Evet"
                    }
                },
                "PARTICIPANTS": {
                    "HOST": "(Yönetici)",
                    "LOWER_ALL_HANDS": "Tüm elleri indir",
                    "RAISED_HAND": "{{ name }} el kaldırdı.",
                    "DENIED_PUBLISH": "{{ name }} video/ses ile katılmayı reddetti.",
                    "PARTICIPANT_LIMIT_REACHED": "Video/ses iletişimi katılımcı limiti aşıldı.",
                    "CALLING": "Aranıyor: {{ participants }}"
                },
                "FILES": {
                    "INFO_TEXT": "Bu çalışma grubuna erişimi olan tüm uzmanlar ve eş yöneticiler, bu bölümdeki dosyaları görebilir ve değiştirebilir.",
                    "DOWNLOAD": "İndir",
                    "SEND_TO_SESSION": "Oturuma Gönder",
                    "DELETE": "Sil",
                    "UPLOAD_FILE": "Dosya Yükle",
                    "FILE_CONTENTS": "Dosya İçeriği:",
                    "FILE_NAME": "Dosya Adı:",
                    "FILE_SIZE": "Dosya Boyutu:",
                    "TOTAL_SIZE": "Toplam Boyut:",
                    "DOWNLOAD_STARTED_SOON": "İndirme yakında başlayacak.",
                    "DOWNLOAD_FAILED": "İndirme başarısız oldu.",
                    "DELETE_MODAL": {
                        "TITLE_DELETE": "Dosyayı sil?",
                        "MESSAGE_DELETE": "Bu dosyayı silmek istediğinizden emin misiniz?",
                        "CANCEL": "İptal",
                        "DELETE": "Sil"
                    }
                },
                "SETTINGS": {
                    "MICROPHONE": "Mikrofon",
                    "CAMERA": "Kamera",
                    "TRANSLATE_OTHERS_MSG_TO": "Diğerlerinin Mesajlarını Şuna Çevir:",
                    "TRANSLATE_MY_MSG_TO": "Benim Mesajlarımı Şuna Çevir:",
                    "CREATE_GUEST_ACCESS": "Misafir Erişimi Oluştur",
                    "GENERATING": "Oluşturuluyor",
                    "GUEST_ACCESS": "Misafir Erişimi",
                    "COPY_LINK": "Kopyala",
                    "LINK_COPIED": "Link panoya kopyalandı",
                    "LINK_GENERATED": "Oturuma katılma linki oluşturuldu",
                    "CANNOT_CREATE_GUEST_ACCESS": "Misafir erişimi oluşturulamadı.",
                    "NO_LINK_PERMISSION": "Misafir erişim linki oluşturma izniniz yok. Lütfen yöneticinizle iletişime geçin.",
                    "SHARE": "Paylaş",
                    "SHARE_LINK_VIA_SMS": "Linki SMS ile paylaş",
                    "SMS_SEND": "Link SMS ile gönderildi",
                    "OPENING": "Açılıyor",
                    "SEND": "Gönder",
                    "SMS_LIMIT_REACHED": "SMS gönderme limiti aşıldı. Lütfen yöneticinizle iletişime geçin.",
                    "ERROR_OCCURED": "Bir hata oluştu.",
                    "SMS_LICENSE_PERMISSION": "SMS göndermek için izniniz yok. Lütfen yöneticinizle iletişime geçin.",
                    "RESHARE": "Linki her dakika bir kez paylaşabilirsiniz.",
                    "DIDNT_GET": "Linki almadınız mı?",
                    "PHONE_NUMBERS": "Son kullanılan telefon numaraları",
                    "RESEND": "Yeniden Gönder",
                    "CANCEL": "İptal",
                    "CONNECT_VIA_FIELD_CODE": "Kullanıcı ile Alan Kimliği üzerinden bağlan",
                    "CONNECT": "Bağlan",
                    "INVITATION_SENT": "Davet kullanıcıya gönderildi.",
                    "INVITATION_COULD_NOT_SENT": "Davet kullanıcıya gönderilemedi.",
                    "FIELD_CODE": "Alan Kimliği"
                }
            }
        },
        "LICENSE_MODAL": {
            "TITLE": "Hesap Lisansı",
            "LOADING": "Yükleniyor",
            "START": "Başlangıç Tarihi",
            "END": "Bitiş Tarihi",
            "TYPE": "Lisans Türü",
            "CONCURRENT_LIMIT_ACCOUNT": "Hesapta Eşzamanlı Kullanıcı Limiti",
            "CONCURRENT_LIMIT_ROOM": "Çalışma Grubundaki Maks. Kullanıcılar",
            "EXPERT_LIMIT": "Maks. Uzmanlar",
            "CON_EXPERT_LIMIT": "Hesapta Eşzamanlı Uzman Limiti",
            "UNLIMITED": "Sınırsız",
            "LIMIT_VALUE": "{{ limit }}",
            "LIMIT2_VALUE": "{{ limit2 }}",
            "EXP_CON_LIMIT_VALUE": "{{ expert_concurrent_limit }}",
            "ROOM_LIMIT_VALUE": "{{ room_limit }}",
            "ARCHIVE": "Video Görüşme Kaydı",
            "ARCHIVE_AVAILABLE": "Mevcut",
            "ARCHIVE_UNAVAILABLE": "Mevcut Değil",
            "CLOSE": "Kapat",
            "EXPERT_USER_BASED": "Uzman Kullanıcı Bazlı",
            "ROOM_LIMIT": "Oluşturulabilecek Çalışma Grupları Limiti",
            "CONCURRENT_USER_BASED": "Eşzamanlı Kullanıcı Bazlı",
            "LIMIT": "Oturum Başına Kullanıcı Limiti",
            "WORKFLOW_USER_LIMIT": "Kullanıcı Limiti",
            "LIMIT2": "Oluşturulabilecek Uzman Limiti",
            "EXPERT_CONCURRENT_LIMIT": "Eşzamanlı Giriş Yapabilen Uzman Limiti",
            "ALLOW_ARCHIVING": "Video Görüşme Kaydı İzni",
            "TRAININGLICENSES": "Akademi Çalışma Grubu Lisansı",
            "CONSUMED": "Tüketilen",
            "LICENCE_HOURS": "{{hours}} saat paketi"
        }
    },
    "MODALS": {
        "ALERT": {
            "TEXT": "Emin misiniz?",
            "CANCEL": "İptal",
            "CONFIRM": "Sil",
            "CONTINUE": "Devam Et"
        },
        "IMAGE-EDITOR": {
            "TITLE": "Resim editörü",
            "CANCEL": "İptal",
            "SAVE": "Kaydet",
            "CROP": "Kırp"
        },
        "TEMPLATE": {
            "CREATE-STEP": "Adım Oluştur",
            "OPTIONS": {
                "TITLE": "Lütfen şablon seçin",
                "FULL": "Tam Sayfa",
                "VERTICAL": "Dikey Sayfa",
                "HORIZONTAL": "Yatay Sayfa"
            },
            "CREATE": "Oluştur",
            "CHANGE": "Değiştir"
        },
        "WORKFLOW-USERS": {
            "TITLE": "Workflow Kullanıcıları",
            "USERS": "Kullanıcılar",
            "SELECTED": "Seçili Kullanıcılar",
            "CLOSE": "Kapat",
            "SAVE": "Kaydet",
            "LIMIT-FULL": "Workflow kullanıcı sınırı dolu"
        },
        "WORKFLOW-SHARING": {
            "TITLE": "Workflow'u Alt Hesaplarla Paylaş",
            "DESCRIPTION": "Bu workflow'a hangi alt hesapların erişebileceğini seçin.",
            "NOT_PARENT_ACCOUNT": "Bu hesap bir ana hesap değil veya alt hesabı bulunmuyor.",
            "NO_CHILDREN": "Bağlı alt hesap yok.",
            "CLOSE": "Kapat",
            "SAVE": "Paylaşım Ayarlarını Kaydet",
            "SHARING_UPDATED": "Paylaşım ayarları başarıyla güncellendi",
            "SHARING_ERROR": "Paylaşım ayarları güncellenemedi"
        },
        "GENERATE-WORKFLOW": {
            "TITLE": "AI İle Otomatik Workflow Oluştur",
            "PROMPT-TEXT": "İstemi buraya giriniz",
            "CONFIRM-BUTTON-TEXT": "GÖNDER",
            "CANCEL-BUTTON-TEXT": "İPTAL",
            "INVALID-WORKFLOW-ERROR": "İstem kullanılarak Worlflow yaratılamadı",
            "PERMISSION-DENIED": "İzniniz yok",
            "PROMPT-REQUIRED": "İstem bulunamadı",
            "INTERNAL-ERROR": "Hata oluştu"
        },
        "SIGNATURE": {
            "ADD-SIGNATURE": "İmza Ekle",
            "DRAW-SIGNATURE": "İmzanı çiz",
            "CLEAR": "Temizle",
            "REQUIRED-NAME": "İsim zorunludur",
            "INSERT": "Ekle",
            "TYPE-SIGNATURE": "İmzanızı yazın",
            "USE-PHOTO": "İmzanızın bir fotoğrafını kullanın",
            "FULL-NAME": "Ad Soyad"
        },
        "WORKFLOW-NEW-LANGUAGE": {
            "ADD-LANGUAGE": "Dil Ekle",
            "NEW-LANGUAGE": "Workflow'a yeni bir dil eklemek üzeresiniz.Varsayılan dildeki tüm içeriği, eklemekte olduğunuz dile otomatik olarak çevirmek istiyor musunuz? İçeriği kendiniz çevirmek istiyorsanız, tüm varsayılan içeriği yeni dile kopyalamayı ve manuel olarak düzenlemeyi seçebilirsiniz.",
            "AUTO-TRANSLATE": "Otomatik çeviri",
            "COPY-CONTENT": "İçeriği varsayılandan kopyala"
        },
        "DEFAULT-LANGUAGE": {
            "PRIMARY-LANGUAGE": "Varsayılan olarak seçtiğiniz dil, kullanıcıların bu Workflow'u cihazlarında görüntüleyecekleri birincil dil olacaktır. Workflow'u oluşturduktan sonra düzenleyicide ek diller ekleyerek çok dilli bir Workflow oluşturabilirsiniz.",
            "DEFAULT-LANGUAGE": "Bu Workflow'un varsayılan dili",
            "CREATE": "OLUŞTUR"
        },
        "USER-DEFAULT-LANGUAGE": {
            "PREFFERED-LANGUAGE": "Workflow içeriğini görüntülemek istediğiniz tercih edilen dili seçin."
        },
        "TABLE-CELL": {
            "AT-LEAST": "Bu alan en az {{selectedCell.templateOptions.min}} olmalıdır",
            "AT-MOST": "Bu alan en fazla {{selectedCell.templateOptions.max}} olmalıdır"
        },
        "OPEN-AI": {
            "DESCRIBE": "Oluşturmak istediğiniz Workflow'u açıklayın"
        },
        "JOIN_MODAL": {
            "JOIN" : "KATIL",
            "CALL": "ARA",
            "CANCEL": "İPTAL",
            "MIRROR_VIDEO": "Görüntüyü Ters Çevir",
            "PREFERRED_RESOLUTION": "Tercih Edilen Çözünürlük",
            "RESOLUTION_NOTE": "Not: Cihazınız tercih ettiğiniz çözünürlüğü desteklemiyorsa, bir sonraki en yüksek çözünürlük kullanılacaktır.",
            "CAM_MIC_PERM_REQUIRED": "Kamera ve mikrofon izni gerekiyor",
            "CAM_MIC_PERM_DENIED": "Kamera veya mikrofon erişimi engellendi",
            "CAM_MIC_CANT_ACCESS": "Kamera veya mikrofonunuza erişemiyoruz",
            "JOIN_CAM_OFF": "Kamera kapalı katıl",
            "JOIN_MIC_OFF": "Mikrofon kapalı katıl",
            "JOIN_CAM_MIC_OFF": "Kamera ve Mikrofon kapalı katıl",
            "JOIN_NO_DEVICE": "Kamera ve mikrofon olmadan katıl",
            "ALLOW_ACCESS": "Tarayıcı ayarlarınızda kameranıza ve mikrofonunuza erişime izin vermeniz gerekir (Erişim izni verdikten sonra, kameranızı veya mikrofonunuzu yine de kapatabilirsiniz).",
            "TRY_AGAIN": "Sayfayı yenileyin ve tarayıcınız tarafından izin istendiğinde 'İzin Ver'i seçin."
        },
        "GET_EXPORT_MODAL": {
            "TITLE": "Son Oturumu Dışa Aktar",
            "MESSAGE1": "Oturum bittikten sonra oturum dışa aktarma indirme bağlantısını almak için lütfen eposta adresinizi girin.",
            "MESSAGE2": "Oturum dışa aktarma, oturumda paylaşılan tüm <strong>sohbet mesajlarını</strong>, <strong>anlık görüntüleri</strong>, <strong>görüşme kayıtlarını</strong> ve <strong>dosyaları</strong> içerir.",
            "EXPORT_NAME_NOT_LOCKED": "Özelleştirilmiş bir dosya adı girerek dışa aktarma dosyasını yeniden adlandırabilirsiniz.",
            "EXPORT_NAME_LOCKED": "Diğer kullanıcı dışa aktarmayı tamamladığında dışa aktarma dosyasını yeniden adlandırabileceksiniz.",
            "EXPORT_NAME_RENAMED": "Dışa aktarma dosyası bu kullanıcı tarafından yeniden adlandırıldı:",
            "EXPORT_NAME_PLACEHOLDER": "Dışa Aktarma Adı",
            "NOTE": "Not: E-posta adresinizi profil menüsünden güncelleyebilirsiniz.",
            "OPEN_PROFILE": "Profili aç",
            "EMAIL": "Eposta",
            "CLOSE": "Kapat",
            "SEND": "Gönder",
            "EXPORT_SUCCEEDED": "Oturum dışa aktarma, oturum sona erdikten sonra gönderilecek.",
            "ENDED_SESSION_EXPORT_SUCCEEDED": "Oturum dışa aktarma gönderildi.",
            "EXPORT_FAILED": "Bir hata oluştu."
        }
    },
    "EXTERNALS": {
        "AD_LOGIN": {
            "MESSAGE": "Bir hata oluştu."
        },
        "AD_ERROR": {
            "ACCOUNT_NOT_FOUND": "Hesabınız Azure AD ile bağlı değil.",
            "PERMISSION_DENIED": "Bu sayfayı görmeye izniniz yok.",
            "INTERNAL_ERROR": "Bir hata oluştu.",
            "CONTACT_MAIL": "Lütfen <strong>{{ contactMail }}</strong> ile iletişime geçin."
        }
    },
    "NOT-FOUND": {
        "TEXT": "Üzgünüz, sayfa bulunamadı.",
        "INFORM": "URL yanlış yazılmış olabilir veya aradığınız sayfa artık mevcut değil."
    },
    "ERRORS": {
        "UPLOAD-ERROR": "Yükleme Hatası",
        "ERROR": "Hata Oluştu"
    },
    "WEB-VERSION": {
        "TASK-TO-COMPLETE": "Tamamlanacak Adım Sayısı",
        "ESTIMATED-DURATION": "Tahmini Süre",
        "START": "BAŞLA",
        "PREVIOUS": "Önceki",
        "NEXT": "Sonraki",
        "SUBMIT": "Gönder",
        "SUCCESS-SUBMIT-MESSAGE": "Workflowunuz başarıyla gönderildi!",
        "SUCCESS-SAVE-MESSAGE": "Workflowunuz başarıyla kaydedildi!",
        "SAVE-AS-DRAFT": "Draft olarak kaydet",
        "CLOSE-WORKFLOW-WARNING-TEXT": "Are you sure you want to close this workflow. Your changes will be removed.",
        "CONTINUE-WORKFLOW-TEXT-MESSAGE": "You started this workflow already. Do you want to continue, or start a new one?",
        "CONTINUE": "Devam et",
        "START-OVER": "BAŞTAN BAŞLA",
        "INCOMPLETE": "Tamamlanmamış",
        "SUBMITTED": "Gönderildi",
        "VERSION": "Versiyon",
        "LAST-SAVED": "Son Kaydedilme",
        "PUBLISHED-AT": "Yayınlandığı Tarih",
        "STATUS": "Durum",
        "SELECT": "Seç",
        "SEARCH": "Ara",
        "SAVE": "Kaydet",
        "CANCEL": "İptal",
        "CLEAR": "TEMİZLE"
    },
    "Number": "Number",
    "Text": "Text",
    "Multiple Choice": "Multiple Choice",
    "Checkboxes": "Checkboxes",
    "Date": "Date",
    "Time": "Time",
    "File Upload": "File Upload",
    "Capture Image": "Capture Image",
    "Capture Video": "Capture Video",
    "PPE": "PPE",
    "QR": "QR",
    "Contains": "Contains",
    "Does not contain": "Does not contain",
    "Is empty": "Is empty",
    "Is not empty": "Is not empty",
    "Equals": "Equals",
    "Not Equals": "Not Equals",
    "Greater than": "Greater than",
    "Less than": "Less than",
    "Greater or Equal": "Greater or Equal",
    "Less or Equal": "Less or Equal",
    "Is": "Is",
    "Is not": "Is not",
    "Starts with": "Starts with",
    "Ends with": "Ends with",
    "Is before": "Is before",
    "Is after": "Is after",
    "Is between": "Is between",
    "Is not between": "Is not between",
    "Is detected": "Is detected",
    "Is not detected": "Is not detected",
    "input": "TEXT INPUT",
    "number": "NUMBER INPUT",
    "datepicker": "DATEPICKER",
    "multicheckbox": "CHECKBOX",
    "radio": "RADIO BUTTON",
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Sayfa başına öğe:",
        "NEXT_PAGE": "Sonraki sayfa",
        "PREVIOUS_PAGE": "Önceki sayfa",
        "FIRST_PAGE": "İlk sayfa",
        "LAST_PAGE": "Son sayfa",
        "RANGE": "{{start}} – {{end}} / {{length}}",
        "RANGE_ZERO": "0 / {{length}}"
    }
}